const iconMoon = {
  IcoMoonType: 'selection',
  icons: [
    {
      icon: {
        paths: [
          'M8.32 2.571c-3.688 0-6.807 2.08-6.807 4.538 0 1.3.874 2.553 2.387 3.427l1.146.662-.414.992c.249-.141.497-.295.733-.46l.52-.367.626.118c.591.107 1.194.166 1.808.166 3.687 0 6.807-2.08 6.807-4.538s-3.12-4.538-6.807-4.538zm0-1.512c4.596 0 8.319 2.706 8.319 6.05s-3.723 6.05-8.32 6.05c-.72 0-1.418-.07-2.08-.189a9.922 9.922 0 0 1-3.285 1.513c-.319.083-.661.142-1.016.19h-.035c-.178 0-.343-.143-.379-.344-.047-.224.107-.366.237-.52.46-.52.98-.98 1.382-1.961C1.23 10.737 0 9.023 0 7.109c0-3.344 3.722-6.05 8.32-6.05zm9.713 13.814c.402.98.922 1.442 1.383 1.962.13.153.283.295.236.52-.047.212-.225.366-.414.342a8.634 8.634 0 0 1-1.016-.189 9.921 9.921 0 0 1-3.285-1.512c-.662.118-1.359.189-2.08.189-2.139 0-4.1-.591-5.578-1.56.343.023.698.047 1.04.047 2.541 0 4.94-.733 6.772-2.056 1.973-1.442 3.06-3.392 3.06-5.507 0-.614-.094-1.217-.271-1.796 1.997 1.099 3.297 2.848 3.297 4.821 0 1.926-1.23 3.628-3.144 4.739z',
        ],
        attrs: [],
        grid: 0,
        tags: ['comments'],
      },
      attrs: [],
      properties: {
        order: 149,
        id: 38,
        name: 'comments',
        prevSize: 32,
        code: 59654,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 6,
    },
    {
      icon: {
        paths: [
          'M950.857 585.143h-365.714v365.714c0 40.229-32.914 73.143-73.143 73.143s-73.143-32.914-73.143-73.143v-365.714h-365.714c-40.229 0-73.143-32.914-73.143-73.143s32.914-73.143 73.143-73.143h365.714v-365.714c0-40.229 32.914-73.143 73.143-73.143s73.143 32.914 73.143 73.143v365.714h365.714c40.229 0 73.143 32.914 73.143 73.143s-32.914 73.143-73.143 73.143z',
        ],
        attrs: [],
        grid: 0,
        tags: ['add'],
      },
      attrs: [],
      properties: {
        order: 83,
        id: 45,
        name: 'add',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M911.181 860.672h44.692c14.464 0 26.189-11.725 26.189-26.189v0-622.305c0-14.464-11.725-26.189-26.189-26.189v0h-273.137l-62.618-121.759c-4.449-8.492-13.2-14.186-23.28-14.188l-169.779-0c-10.050 0.009-18.774 5.679-23.156 13.993l-0.069 0.143-63.247 121.81h-103.736l-186.337-185.989-50.514 50.565 135.424 135.424h-67.246c-0.002-0-0.003-0-0.005-0-14.464 0-26.189 11.725-26.189 26.189l0 0v622.3c0.012 14.459 11.73 26.177 26.188 26.189l741.935 0 163.328 163.328 50.565-50.509zM292.26 512.026c-0-0.049-0-0.106-0-0.164 0-47.96 15.492-92.301 41.745-128.293l-0.432 0.621-196.536-196.644h101.074l146.028 146.028c35.475-25.665 79.853-41.052 127.825-41.052 60.539 0 115.355 24.505 155.069 64.137l-0.004-0.004-50.58 50.591c-26.807-26.652-63.759-43.126-104.558-43.126-28.128 0-54.428 7.83-76.837 21.43l0.659-0.371 101.376 101.407-50.534 50.54-101.484-101.489c-13.383 21.754-21.311 48.108-21.311 76.313 0 40.847 16.627 77.811 43.483 104.492l0.008 0.008-50.601 50.601c-39.748-39.645-64.351-94.457-64.389-155.016l-0-0.007zM808.96 859.505l-169.129-169.129c-35.472 25.665-79.847 41.052-127.816 41.052-60.49 0-115.265-24.468-154.968-64.046l0.006 0.006 50.565-50.56c26.801 26.618 63.728 43.069 104.498 43.069 28.124 0 54.419-7.828 76.825-21.424l-0.659 0.371-101.371-101.35 50.54-50.54 101.412 101.412c13.381-21.753 21.307-48.105 21.307-76.309 0-40.811-16.597-77.745-43.409-104.421l-0.006-0.006 50.621-50.621c39.721 39.596 64.297 94.364 64.297 154.872 0 48.038-15.49 92.458-41.748 128.538l0.435-0.627 219.715 219.771z',
        ],
        attrs: [{}, {}],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['icons_camera_unavailable'],
        colorPermutations: {
          1804121255255255179871001: [{}, {}],
        },
      },
      attrs: [{}, {}],
      properties: {
        order: 16,
        id: 5,
        name: 'icons_camera_unavailable',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 7,
      setId: 0,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M629.334 560h-576c-26.4 0-48-21.6-48-48s21.6-48 48-48h576c26.4 0 48 21.6 48 48s-21.6 48-48 48z',
        ],
        attrs: [],
        grid: 0,
        tags: ['icons-minus-minus'],
      },
      attrs: [],
      properties: {
        order: 35,
        id: 0,
        name: 'icons-minus-minus',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1136.373 443.509c2.315 1.252 19.058 10.24 23.402 12.523-0.502 0.835-8.518 16.86-18.647 37.092-17.317 34.581-40.777 81.457-43.354 85.801-2.452-1.957-17.154-12.699-31.379-23.095h-0.007c-14.029-10.26-27.615-20.18-28.555-21.034 0.496-0.62 2.107-2.713 4.135-5.342 4.52-5.857 11.101-14.395 12.034-15.367 2.107 1.481 24.7 18.015 34.692 25.391 1.918-3.939 10.26-20.676 19.443-39.095h0.007v-0.007c12.823-25.724 27.296-54.742 28.228-56.868zM1154.446 502.21c-3.602 0-6.522 2.92-6.522 6.522v0 84.79h-117.401v-123.924h71.745c0.003 0 0.007 0 0.011 0 3.602 0 6.522-2.92 6.522-6.522s-2.92-6.522-6.522-6.522c-0.102 0-0.204 0.002-0.306 0.007l0.014-0.001v-0.007h-78.268c-3.45 0-6.242 2.922-6.242 6.522v58.701h-6.522c-3.602 0-6.522 2.92-6.522 6.522v0 6.522c0 3.602 2.92 6.522 6.522 6.522v0h6.522v58.701c0 3.6 2.792 6.522 6.242 6.522h131.007c3.45 0 6.242-2.922 6.242-6.522v-58.701h6.522c3.602 0 6.522-2.92 6.522-6.522v0-6.522c0-3.602-2.92-6.522-6.522-6.522v0h-6.522v-13.045c0-3.602-2.92-6.522-6.522-6.522v0zM1533.098 521.073c-6.807-3.785-14.929-6.014-23.572-6.014-0.043 0-0.087 0-0.13 0l0.007-0c-13.012 0-24.009 4.37-32.957 13.084-8.955 8.727-13.442 19.436-13.442 32.109s4.429 23.304 13.266 31.855c8.844 8.492 19.841 12.738 32.957 12.738 7.964 0 15.921-2.061 23.865-6.177 0 0 0.346-0.215 0.352-0.58v-25.535l-1.154-0.417c-4.598 5.564-8.59 9.294-11.942 11.199-3.457 1.95-7.442 2.922-11.975 2.922-7.103 0-12.921-2.446-17.499-7.357-4.52-4.918-6.79-11.205-6.79-18.902 0-7.52 2.348-13.749 7.044-18.726 4.696-4.97 10.573-7.448 17.669-7.448 4.533 0 8.459 0.998 11.792 3 3.424 1.97 7.331 5.609 11.694 10.944l1.161-0.411v-25.711c-0.007-0.372-0.346-0.574-0.346-0.574zM1270.197 521.268c-6.807-3.785-14.929-6.014-23.572-6.014-0.043 0-0.087 0-0.13 0l0.007-0c-13.012 0-24.009 4.37-32.964 13.084-8.949 8.72-13.436 19.436-13.436 32.109s4.429 23.304 13.266 31.855c8.844 8.492 19.841 12.738 32.957 12.738 7.964 0 15.921-2.061 23.865-6.177 0 0 0.346-0.215 0.352-0.587v-25.535l-1.154-0.411c-4.598 5.557-8.59 9.294-11.949 11.199-3.45 1.944-7.435 2.922-11.975 2.922-7.096 0-12.914-2.452-17.493-7.357-4.526-4.918-6.79-11.212-6.79-18.902 0-7.52 2.348-13.749 7.044-18.732 4.696-4.97 10.566-7.448 17.669-7.448 4.533 0 8.459 1.004 11.792 3 3.424 1.97 7.331 5.616 11.694 10.951l1.161-0.411v-25.711c-0.007-0.372-0.346-0.574-0.346-0.574zM1306.011 524.131l0.007-54.533h-19.352v132.187h19.352v-40.503l0.013-2.022c0.17-9.249 1.513-15.856 4.024-19.815 2.557-3.887 6.842-5.968 12.855-6.242l1.422-0.033 1.402 0.033c4.553 0.248 7.912 1.741 10.077 4.481 2.381 3.007 3.568 7.866 3.568 14.571v49.53h19.345v-51.33l-0.026-2.159c-0.28-10.592-2.681-18.386-7.194-23.382-5.296-5.727-12.242-8.779-20.839-9.157l-1.865-0.046-1.774 0.052c-7.077 0.378-13.619 3.065-19.626 8.042l-0.737 0.633 0.007-0.874-0.659 0.567zM1413.355 515.255c12.503 0 22.424 3.998 29.722 11.994 7.227 7.925 10.827 18.889 10.827 32.872v5.192h-60.044c0.6 6.405 2.759 11.499 6.464 15.314 3.829 3.887 8.733 5.824 14.753 5.824 4.683 0 8.531-1.109 11.564-3.313 2.544-1.878 5.414-5.153 8.596-9.796l17.78 9.477c-2.070 3.283-4.241 6.135-6.635 8.781l0.048-0.054c-2.85 3.111-5.909 5.674-9.17 7.677-3.047 1.908-6.578 3.427-10.339 4.368l-0.254 0.054c-3.571 0.888-7.671 1.397-11.89 1.397-0.138 0-0.275-0.001-0.412-0.002l0.021 0c-12.666 0-22.874-4.083-30.57-12.242-7.683-8.218-11.525-19.091-11.525-32.611 0-13.39 3.724-24.263 11.179-32.598 7.52-8.218 17.499-12.334 29.885-12.334zM1432.256 548.192c-2.694-10.325-9.464-14.427-18.575-14.427-10.977 0-17.062 7.846-18.778 14.421h37.353z',
          'M-0.352 579.812v-103.939c5.434-0.458 11.761-0.72 18.149-0.72 12.552 0 24.868 1.009 36.872 2.95l-1.317-0.176c5.309 1.37 10.057 4.292 13.606 8.355 3.408 3.876 5.676 8.831 6.233 14.292l0.009 0.109c1.728 8.036 2.717 17.268 2.717 26.732s-0.989 18.696-2.87 27.599l0.153-0.867c-0.741 6.473-3.718 12.139-8.127 16.307l-0.013 0.012c-4.475 4.234-10.369 7.010-16.897 7.546l-0.1 0.007c-15.347 1.454-31.483 1.278-48.415 1.794zM15.171 489.048c-0.833 10.079-1.308 21.817-1.308 33.665 0 15.622 0.826 31.052 2.436 46.247l-0.163-1.892h18.432c3.261 0.261 6.548-0.163 9.627-1.226 3.206-1.124 5.959-2.813 8.271-4.97l-0.014 0.013c2.361-2.198 4.213-4.859 5.433-7.807 1.22-2.942 1.781-6.105 1.644-9.281 0.62-10.52 0.444-21.041 0-31.477-0.258-4.322-1.272-8.343-2.912-12.025l0.087 0.22c-1.226-3.331-3.348-6.090-6.075-8.066l-0.050-0.034c-2.714-1.97-6.074-3.208-9.714-3.364l-0.037-0.001c-8.022-0.261-16.404 0-25.306 0h-0.352zM243.934 579.727c-7.494 0.509-14.721 1.539-22.045 1.539-2.805 0.372-5.674 0.196-8.414-0.515-2.886-0.757-5.41-2.001-7.609-3.653l0.056 0.040c-2.234-1.673-4.085-3.722-5.491-6.068l-0.053-0.095c-1.337-2.231-2.276-4.855-2.644-7.659l-0.011-0.103c-1.414-5.359-2.227-11.512-2.227-17.855 0-7.924 1.268-15.553 3.612-22.693l-0.146 0.514c1.356-5.167 4.366-9.492 8.418-12.486l0.061-0.043c3.87-2.867 8.738-4.589 14.009-4.589 0.248 0 0.495 0.004 0.742 0.011l-0.036-0.001c11.551-0.43 23.102 0 35.273 0 0.457 2.407 0.783 4.826 0.978 7.272v76.135c0.404 2.896 0.13 5.837-0.789 8.622-0.926 2.778-2.478 5.322-4.559 7.442-2.039 2.077-4.519 3.712-7.29 4.755l-0.139 0.046c-2.811 1.037-5.831 1.448-8.831 1.207-13.084 1.5-26.337 0.6-39.069-2.655v-11.714c7.051 1.031 13.136 2.139 19.306 2.909 4.533 0.6 9.099 0.946 13.671 1.031 9.79 0 13.319-3.339 14.199-12.575 0.183-2.022 0.183-4.057 0-6.079-0.174-1.028-0.511-1.949-0.987-2.78l0.022 0.041zM243.934 568.431c2.055-17.415 1.787-35.005-0.789-52.354h-18.341c-2.749 0.033-5.281 0.936-7.341 2.445l0.036-0.025c-2.063 1.505-3.612 3.605-4.405 6.046l-0.024 0.085c-2.086 5.949-3.292 12.807-3.292 19.947 0 6.435 0.979 12.642 2.797 18.479l-0.118-0.44c0.43 2.4 1.774 4.546 3.77 6.020s4.487 2.165 6.985 1.937c6.79-0.261 13.586-1.37 20.637-2.478l0.091 0.339zM129.905 509.065c11.153-3.176 22.828-4.253 34.399-3.163 0.061-0.001 0.133-0.001 0.206-0.001 4.374 0 8.382 1.562 11.498 4.16l-0.029-0.023c3.242 2.707 5.361 6.464 5.961 10.579 0.913 4.65 1.389 9.379 1.409 14.114v35.501c0 2.909-0.437 5.903-0.704 9.751l-12.171-0.515-2.022-6.242c-0.998 0.13-1.97 0.359-2.915 0.685-5.404 2.68-11.838 5.211-18.503 7.21l-0.901 0.232c-2.857 1.004-5.935 1.272-8.936 0.783-3.132-0.523-5.901-1.791-8.21-3.616l0.038 0.029c-2.314-1.829-4.124-4.196-5.254-6.917l-0.042-0.114c-0.773-1.851-1.222-4.001-1.222-6.256 0-0.842 0.063-1.669 0.183-2.477l-0.011 0.091c-0.063-1.061-0.099-2.302-0.099-3.551s0.036-2.49 0.107-3.722l-0.008 0.17c-0.022-0.313-0.035-0.679-0.035-1.047 0-3.943 1.44-7.549 3.822-10.323l-0.018 0.021c2.678-3.115 6.443-5.229 10.7-5.751l0.081-0.008c7.24-1.239 14.538-2.1 21.869-2.563l9.79-0.854c0.183-2.85 0.183-5.707 0-8.557-1.148-8.042-5.022-11.121-13.671-10.697-4.533 0.437-9.040 1.122-13.495 2.055l-11.903 2.224 0.085-11.205zM168.36 545.935h-17.636c-2.433 0.189-4.846 0.502-7.24 0.939-2.087 0.248-4.037 1.174-5.511 2.635-1.422 1.403-2.372 3.28-2.593 5.375l-0.003 0.039c-2.824 12.914 3.966 18.902 17.108 14.962 1.37-0.326 2.694-0.783 3.966-1.37 15.001-7.781 13.938-6.666 11.91-22.58zM887.032 579.388c-1.322-0.136-2.856-0.214-4.409-0.214s-3.087 0.078-4.6 0.23l0.191-0.016c-2.576 0.567-5.27 0.32-7.683-0.717-2.427-1.048-4.39-2.786-5.689-4.967l-0.031-0.056c-8.825-9.66-16.762-19.241-24.961-28.913-0.881-0.939-1.057-2.478-2.648-3.079-1.455 8.386-2.287 18.044-2.287 27.896 0 3.308 0.094 6.595 0.279 9.857l-0.020-0.452h-12.875v-102.661c1.422-0.372 2.863-0.652 4.324-0.848 2.381 0 4.761 0 8.199 0.424v56.809c7.585-6.933 13.671-11.805 18.876-17.545 2.87-3.417 6.707-5.935 11.089-7.138l0.155-0.036c1.774-0.498 3.812-0.785 5.916-0.785 2.7 0 5.29 0.472 7.691 1.337l-0.158-0.050-30.074 27.204 38.716 43.719zM417.675 544.057c-1.117 7.782-2.502 14.47-4.249 21.010l0.284-1.247c-1.464 4.627-4.135 8.524-7.644 11.448l-0.039 0.032c-3.524 2.939-7.914 4.953-12.736 5.614l-0.132 0.015c-2.435 0.582-5.276 0.979-8.188 1.105l-0.096 0.003c-20.552 0-31.666-7.357-35.286-26.259-0.738-3.645-1.16-7.836-1.16-12.125 0-6.068 0.845-11.938 2.424-17.5l-0.109 0.451c1.358-6.118 4.72-11.295 9.349-14.933l0.056-0.042c4.605-3.624 10.488-5.812 16.882-5.812 0.059 0 0.117 0 0.176 0.001l-0.009-0c28.75-2.478 39.16 11.721 39.329 35.24v3.085l1.148-0.085zM362.47 543.027h0.796v7.103c0.789 16.254 7.051 21.471 23.806 20.447 0.096 0.002 0.208 0.004 0.321 0.004 3.196 0 6.146-1.055 8.521-2.835l-0.037 0.026c2.524-1.891 4.305-4.553 5.042-7.546 1.703-5.112 2.686-10.997 2.686-17.111s-0.983-12-2.799-17.506l0.113 0.395c-2.642-7.696-7.501-10.351-17.636-10.52-10.142-0.17-15.523 2.218-18.165 10.351-1.311 5.661-2.191 11.414-2.648 17.193zM288.742 579.127h-13.41v-70.917c6.177-1.37 11.818-2.739 15.086 4.957 6.305-5.047 14.397-8.099 23.202-8.099 1.145 0 2.278 0.052 3.397 0.153l-0.144-0.011c11.994 0.861 17.636 6.079 18.608 17.715v55.603h-13.142c-0.383-1.83-0.665-4-0.784-6.214l-0.005-0.113v-39.61c0.105-1.357 0.165-2.938 0.165-4.533s-0.060-3.176-0.178-4.741l0.013 0.208c-0.090-1.256-0.444-2.411-1.007-3.435l0.022 0.043c-0.592-1.074-1.366-1.975-2.289-2.692l-0.020-0.015c-1.496-1.172-3.404-1.88-5.478-1.88-0.484 0-0.958 0.038-1.421 0.113l0.051-0.007c-4.164 0.205-8.043 1.218-11.553 2.883l0.184-0.079c-3.66 1.725-6.767 4.033-9.34 6.839l-0.020 0.022c-1.552 2.152-2.328 4.735-2.205 7.357v35.501l0.261 10.951zM759.156 579.212h-12.614v-71.002c6.085-0.77 11.903-2.394 14.903 5.387 3.573-2.99 7.816-5.315 12.46-6.718l0.252-0.065c3.088-0.949 6.637-1.495 10.314-1.495 1.459 0 2.897 0.086 4.31 0.253l-0.171-0.016c4.676 0 9.164 1.8 12.471 5.009s5.166 7.566 5.166 12.099c0.528 10.097 0 20.278 0 30.459v25.659h-14.108v-51.754c0-10.52-5.029-13.345-14.91-10.605-4.033 1.289-7.505 2.825-10.774 4.679l0.28-0.146c-2.524 1.19-4.557 3.072-5.901 5.402l-0.034 0.064c-1.344 2.374-1.891 5.1-1.559 7.794 0.528 11.805 0 23.611 0 35.501 0.528 3.163 0.176 6.157-0.085 9.496zM730.314 468.092h-16.319c-6.022-14.958-16.090-27.233-28.851-35.808l-0.278-0.176c-12.633-8.515-28.196-13.593-44.945-13.593-0.032 0-0.064 0-0.096 0l0.005-0c-16.084 0-31.79 4.742-45.036 13.592-13.040 8.751-23.11 21.026-28.949 35.464l-0.186 0.519c-2.465 0-4.846 0.515-7.233 0.6h-7.051c-0.24-0.962-0.377-2.066-0.377-3.202s0.138-2.241 0.397-3.297l-0.020 0.095c0.509-2.1 1.5-4.070 2.909-5.74 6.209-10.419 14.238-19.099 23.731-25.856l0.258-0.175c9.334-6.656 20.381-11.593 32.327-14.081l0.565-0.098c8.768-2.501 18.838-3.938 29.244-3.938 6.996 0 13.84 0.65 20.476 1.893l-0.685-0.107c17.108 3.17 32.244 9.922 45.192 19.471l-0.299-0.211c8.641 6.273 15.628 14.292 20.542 23.578l0.18 0.372c1.676 2.909 2.648 6.072 4.5 10.697zM478.88 506.417c0.378 1.487 0.652 3 0.796 4.533v7.018l-16.932-1.115c-2.824 0-5.642-0.6-8.818-0.515-7.501 0-9.966 2.055-10.847 7.188-0.887 5.133 0.704 8.557 7.494 11.29 6.79 2.739 13.227 4.533 20.023 6.418 3.62 0.763 6.848 2.746 9.105 5.596s3.405 6.379 3.235 9.979c0.13 2.022 0.13 4.044 0 6.066-1.324 13.606-5.642 17.623-20.023 18.054h-25.215c-2.087-0.131-4.021-0.405-5.903-0.816l0.255 0.047v-10.436c8.818 0 18.080 1.024 27.074 0.939 9.001-0.085 12.262-4.279 10.142-12.321-0.511-1.452-1.273-2.699-2.244-3.751l0.007 0.007c-0.99-1.071-2.18-1.941-3.512-2.554l-0.069-0.028c-4.435-1.762-10.080-3.58-15.856-5.073l-1.076-0.236c-14.819-4.272-19.756-12.49-16.404-26.689 0.437-3.587 2.106-6.72 4.564-9.019l0.008-0.008c2.494-2.335 5.771-3.862 9.397-4.145l0.054-0.003c11.551-1.024 22.926-0.424 34.744-0.424zM651.564 476.219h13.84v91.188h37.927v11.721h-51.063c-1.304-17.014-2.047-36.847-2.047-56.854 0-16.202 0.487-32.29 1.448-48.25l-0.106 2.195zM633.041 569.122l1.057 10.436c-5.788 1.584-12.433 2.494-19.291 2.494-6.235 0-12.295-0.752-18.093-2.171l0.52 0.108c-3.741-0.807-6.965-2.651-9.453-5.213l-0.004-0.005c-2.442-2.518-4.139-5.77-4.728-9.395l-0.014-0.101c-1.367-6.674-2.15-14.345-2.15-22.199s0.783-15.524 2.275-22.939l-0.124 0.74c0.783-4.044 2.948-7.709 6.151-10.397 3.102-2.602 7.091-4.238 11.457-4.402l0.035-0.001c10.403-0.6 20.897 0 32.096 0v12.314l-15.784-1.624c-1.32-0.109-2.857-0.171-4.409-0.171s-3.089 0.062-4.609 0.184l0.2-0.013c-7.677 0.77-11.023 3.594-11.466 10.781-0.274 4.842-0.43 10.507-0.43 16.208s0.156 11.366 0.464 16.991l-0.034-0.783c0 7.957 3.705 10.781 12.171 10.781s15.432-1.194 24.165-1.624zM536.915 568.692l0.613 11.721c-8.114 0-15.347 0.77-22.58 0-7.227-0.77-11.199-3.763-11.727-11.629-0.528-7.872-0.444-16.254-0.528-24.38v-25.665l-7.233-2.309c-1.148-7.957-1.148-7.957 6.705-10.866l1.239-17.108h12.431l0.965 17.962h20.284l1.239 10.012-21.347 1.194c0 3.424-0.704 6.672-0.789 9.927v29.429c0 12.399 2.465 14.284 15.164 11.975l5.557-0.261zM565.835 579.127h-13.756v-70.91h13.495c0.437 23.611 0.085 47.052 0.261 70.917zM715.059 508.211h12.523v70.747h-12.086c-1.040-11.419-1.633-24.699-1.633-38.117 0-11.483 0.434-22.864 1.288-34.129l-0.091 1.499zM106.007 579.212h-12.438v-70.995h11.91c2.563 23.591 2.739 47.378 0.522 71.002zM565.744 481.776v12.321h-13.756v-12.321h13.762zM714.706 481.26h13.051v13.090h-13.051v-13.090zM93.569 481.521h12.699l0.887 12.321h-13.586v-12.321z',
          'M1072.311 224.986l88.057-40.523-54.905 149.263-153.3-53.457 78.176-35.97c-48.761-76.82-150.339-107.377-236.381-67.936-57.768 26.481-94.847 78.254-103.828 135.233l-44.175-15.347c13.482-67.799 58.962-128.665 128.254-160.429 109.124-50.026 238.24-9.973 298.101 89.16z',
          'M578.69 824.927l98.265-25.633c41.051 107.194 160.266 168.438 276.434 138.247 74.028-19.241 129.989-71.236 155.746-135.612l-40.634-22.756c-19.339 54.507-65.36 99.008-127.074 115.053-91.495 23.78-185.357-23.343-219.586-106.646l79.285-20.689-141.018-79.272-81.418 137.307zM1105.47 372.866l-153.306-53.463 208.205-95.812-54.898 149.276z',
        ],
        attrs: [
          {
            fill: 'rgb(7, 7, 15)',
          },
          {
            fill: 'rgb(7, 7, 15)',
          },
          {
            fill: 'rgb(11, 46, 107)',
          },
          {
            fill: 'rgb(11, 46, 107)',
          },
        ],
        width: 1539,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['icon-dl-chec'],
        colorPermutations: {
          1146107177151: [
            {
              f: 0,
            },
            {
              f: 0,
            },
            {
              f: 1,
            },
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(7, 7, 15)',
        },
        {
          fill: 'rgb(7, 7, 15)',
        },
        {
          fill: 'rgb(11, 46, 107)',
        },
        {
          fill: 'rgb(11, 46, 107)',
        },
      ],
      properties: {
        order: 13,
        id: 0,
        name: 'icon-dl-chec',
        prevSize: 32,
        code: 59648,
        codes: [59648, 59649, 59650, 59651],
      },
      setIdx: 1,
      setId: 3,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M321.008 1024c-68.246-142.008-31.902-223.378 20.55-300.044 57.44-83.956 72.244-167.066 72.244-167.066s45.154 58.7 27.092 150.508c79.772-88.8 94.824-230.28 82.782-284.464 180.314 126.012 257.376 398.856 153.522 601.066 552.372-312.532 137.398-780.172 65.154-832.85 24.082 52.676 28.648 141.85-20 185.126-82.352-312.276-285.972-376.276-285.972-376.276 24.082 161.044-87.296 337.144-194.696 468.73-3.774-64.216-7.782-108.528-41.55-169.98-7.58 116.656-96.732 211.748-120.874 328.628-32.702 158.286 24.496 274.18 241.748 396.622z',
        ],
        tags: ['fire', 'flame', 'hot', 'popular'],
        defaultCode: 59817,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'fire, flame',
        name: 'fire',
        order: 2,
        id: 170,
        prevSize: 32,
        code: 59817,
      },
      setIdx: 3,
      setId: 1,
      iconIdx: 169,
    },
    {
      icon: {
        paths: [
          'M545.984 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z',
          'M487.936 601.792h91.264v-18.24c0-11.264 1.728-21.056 5.12-29.312 3.52-8.32 9.472-16.064 17.984-23.424 8.512-7.616 20.352-15.744 35.52-24.512 24.32-14.272 42.752-30.72 55.168-49.28 12.416-18.88 18.56-41.28 18.56-67.2v-0.768c0-26.176-6.848-49.28-20.608-69.248-14.365-20.494-33.756-36.555-56.416-46.571l-0.864-0.341c-24.256-11.264-52.928-16.896-85.76-16.896-35.2 0-65.152 6.080-89.984 18.304-23.8 11.474-43.162 28.925-56.63 50.442l-0.33 0.566c-12.796 21.291-20.433 46.952-20.608 74.383l-0 0.049v0.704l93.056-0.32 0.704-0.384c0.387-12.365 3.904-23.831 9.779-33.733l-0.179 0.325c5.676-9.522 13.647-17.143 23.17-22.244l0.318-0.156c9.92-5.312 21.376-7.936 34.496-7.936s24.576 2.56 34.496 7.552c18.424 8.786 30.937 27.247 30.976 48.635l0 0.005v0.64c0 10.88-1.664 20.288-5.12 28.288-4.314 9.193-10.372 16.911-17.806 23.013l-0.114 0.091c-10.265 8.738-21.67 16.84-33.756 23.905l-1.124 0.607c-14.633 8.385-27.218 18.218-38.229 29.587l-0.043 0.045c-9.6 10.56-16.384 22.656-20.288 36.224-2.621 10.088-4.126 21.67-4.126 33.602 0 4.8 0.243 9.543 0.719 14.217l-0.048-0.588 0.64 19.968zM537.216 768c19.328 0 34.496-5.12 45.504-15.488 11.264-10.368 16.896-24.384 16.896-42.112 0-18.112-5.632-32.256-16.896-42.368-11.008-10.368-26.24-15.552-45.504-15.552-19.328 0-34.56 5.184-45.888 15.552-11.264 10.112-16.896 24.256-16.896 42.368 0 17.728 5.632 31.744 16.896 42.112 11.264 10.304 26.56 15.488 45.888 15.488z',
          'M545.984 950.848v0c-242.369 0-438.848-196.479-438.848-438.848s196.479-438.848 438.848-438.848v0c242.369 0 438.848 196.479 438.848 438.848s-196.479 438.848-438.848 438.848zM545.984 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512v0c-282.77 0-512 229.23-512 512s229.23 512 512 512v0z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgba(11, 46, 107, 1)',
          },
          {
            fill: 'rgba(140, 150, 162, 1)',
          },
        ],
        width: 1088,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['tooltip-question-circle'],
        colorPermutations: {
          1146107114015016212552552551: [
            {
              f: 2,
            },
            {
              f: 0,
            },
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgba(11, 46, 107, 1)',
        },
        {
          fill: 'rgba(140, 150, 162, 1)',
        },
      ],
      properties: {
        order: 38,
        id: 1,
        name: 'tooltip-question-circle',
        prevSize: 32,
        code: 59650,
        codes: [59650, 59651, 59652],
      },
      setIdx: 4,
      setId: 9,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1150.458 843.071l-454.332-782.792c-10.553-18.209-25.799-33.345-44.203-43.872s-39.305-16.073-60.581-16.073c-21.276 0-42.176 5.545-60.578 16.073s-33.651 25.663-44.201 43.872l-456.067 782.792c-10.636 18.142-16.293 38.702-16.411 59.654s5.304 41.574 15.734 59.836c10.43 18.256 25.507 33.525 43.746 44.294s39.011 16.668 60.269 17.124h912.137c21.356-0.256 42.268-6.019 60.666-16.708s33.638-25.936 44.203-44.231c10.564-18.29 16.088-38.986 16.020-60.035-0.063-21.043-5.717-41.705-16.401-59.932v0zM647.629 824.866h-115.458v-113.778h115.458v113.778zM647.629 540.421c0 15.088-6.081 29.561-16.907 40.227s-25.509 16.663-40.818 16.663c-15.314 0-29.998-5.996-40.824-16.663s-16.909-25.139-16.909-40.227v-113.778c0-15.088 6.083-29.558 16.909-40.227s25.51-16.662 40.824-16.662c15.309 0 29.992 5.994 40.818 16.662s16.907 25.139 16.907 40.227v113.778z',
          'M647.657 711.111h-115.463v113.778h115.463v-113.778z',
          'M647.657 540.444v-113.778c0-15.088-6.087-29.558-16.913-40.227s-25.509-16.662-40.818-16.662c-15.314 0-29.997 5.994-40.823 16.662s-16.909 25.139-16.909 40.227v113.778c0 15.088 6.082 29.559 16.909 40.226s25.509 16.663 40.823 16.663c15.309 0 29.992-5.996 40.818-16.663s16.913-25.138 16.913-40.226z',
        ],
        attrs: [
          {
            fill: 'rgb(239, 177, 21)',
          },
          {
            fill: 'rgb(7, 7, 15)',
          },
          {
            fill: 'rgb(7, 7, 15)',
          },
        ],
        width: 1195,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['alert-icon-black-exclamation-mark'],
        colorPermutations: {
          23917721177151: [
            {
              f: 1,
            },
            {
              f: 0,
            },
            {
              f: 0,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(239, 177, 21)',
        },
        {
          fill: 'rgb(7, 7, 15)',
        },
        {
          fill: 'rgb(7, 7, 15)',
        },
      ],
      properties: {
        order: 2,
        id: 0,
        name: 'alert-icon-black-exclamation-mark',
        prevSize: 32,
        code: 59648,
        codes: [59648, 59649, 59650],
      },
      setIdx: 0,
      setId: 6,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM716.8 563.2h-153.6v153.6c0 28.16-23.040 51.2-51.2 51.2s-51.2-23.040-51.2-51.2v-153.6h-153.6c-28.16 0-51.2-23.040-51.2-51.2s23.040-51.2 51.2-51.2h153.6v-153.6c0-28.16 23.040-51.2 51.2-51.2s51.2 23.040 51.2 51.2v153.6h153.6c28.16 0 51.2 23.040 51.2 51.2s-23.040 51.2-51.2 51.2z',
        ],
        attrs: [],
        grid: 0,
        tags: ['add_circle'],
      },
      attrs: [],
      properties: {
        order: 84,
        id: 44,
        name: 'add_circle',
        prevSize: 32,
        code: 59651,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M512 256c-28.16 0-51.2 23.040-51.2 51.2v153.6h-153.6c-28.16 0-51.2 23.040-51.2 51.2s23.040 51.2 51.2 51.2h153.6v153.6c0 28.16 23.040 51.2 51.2 51.2s51.2-23.040 51.2-51.2v-153.6h153.6c28.16 0 51.2-23.040 51.2-51.2s-23.040-51.2-51.2-51.2h-153.6v-153.6c0-28.16-23.040-51.2-51.2-51.2zM512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6c225.792 0 409.6 183.808 409.6 409.6s-183.808 409.6-409.6 409.6z',
        ],
        attrs: [],
        grid: 0,
        tags: ['add_circle_outlined'],
      },
      attrs: [],
      properties: {
        order: 85,
        id: 43,
        name: 'add_circle_outlined',
        prevSize: 32,
        code: 59656,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M102.4 204.8h-102.4v716.8c0 56.32 46.080 102.4 102.4 102.4h716.8v-102.4h-716.8v-716.8zM921.6 0h-614.4c-56.32 0-102.4 46.080-102.4 102.4v614.4c0 56.32 46.080 102.4 102.4 102.4h614.4c56.32 0 102.4-46.080 102.4-102.4v-614.4c0-56.32-46.080-102.4-102.4-102.4zM870.4 460.8h-204.8v204.8h-102.4v-204.8h-204.8v-102.4h204.8v-204.8h102.4v204.8h204.8v102.4z',
        ],
        attrs: [],
        grid: 0,
        tags: ['duplicate'],
      },
      attrs: [],
      properties: {
        order: 128,
        id: 27,
        name: 'duplicate',
        prevSize: 32,
        code: 59663,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 18,
    },
    {
      icon: {
        paths: [
          'M542.118 859.558l249.976 151.191c45.779 27.708 101.798-13.252 89.751-65.054l-66.259-284.311 221.064-191.548c40.358-34.936 18.673-101.195-34.334-105.412l-290.936-24.696-113.845-268.649c-20.48-48.791-90.353-48.791-110.833 0l-113.845 268.047-290.936 24.696c-53.007 4.216-74.692 70.475-34.334 105.412l221.064 191.548-66.259 284.311c-12.047 51.802 43.972 92.762 89.751 65.054l249.976-150.588z',
        ],
        attrs: [],
        grid: 0,
        tags: ['favorites_selected'],
      },
      attrs: [],
      properties: {
        order: 110,
        id: 23,
        name: 'favorites_selected',
        prevSize: 32,
        code: 59671,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 22,
    },
    {
      icon: {
        paths: [
          'M1002.918 363.821l-291.539-25.299-113.845-268.047c-20.48-48.791-90.353-48.791-110.833 0l-113.845 268.649-290.936 24.696c-53.007 4.216-74.692 70.475-34.334 105.412l221.064 191.548-66.259 284.311c-12.047 51.802 43.972 92.762 89.751 65.054l249.976-150.588 249.976 151.191c45.779 27.708 101.798-13.252 89.751-65.054l-66.259-284.913 221.064-191.548c40.358-34.936 19.275-101.195-33.732-105.412v0zM542.118 746.918l-226.485 136.734 60.235-257.807-199.981-173.478 263.831-22.889 102.4-242.748 103.002 243.351 263.831 22.889-199.981 173.478 60.235 257.807-227.087-137.336z',
        ],
        attrs: [],
        grid: 0,
        tags: ['favorites_outline'],
      },
      attrs: [],
      properties: {
        order: 109,
        id: 22,
        name: 'favorites_outline',
        prevSize: 32,
        code: 59680,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 23,
    },
    {
      icon: {
        paths: [
          'M56.889 1024h910.222c31.289 0 56.889-38.4 56.889-85.333s-25.6-85.333-56.889-85.333h-910.222c-31.289 0-56.889 38.4-56.889 85.333s25.6 85.333 56.889 85.333zM56.889 597.333h910.222c31.289 0 56.889-38.4 56.889-85.333s-25.6-85.333-56.889-85.333h-910.222c-31.289 0-56.889 38.4-56.889 85.333s25.6 85.333 56.889 85.333zM0 85.333c0 46.933 25.6 85.333 56.889 85.333h910.222c31.289 0 56.889-38.4 56.889-85.333s-25.6-85.333-56.889-85.333h-910.222c-31.289 0-56.889 38.4-56.889 85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['grip_handles'],
      },
      attrs: [],
      properties: {
        order: 123,
        id: 21,
        name: 'grip_handles',
        prevSize: 32,
        code: 59689,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 24,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM563.2 870.4h-102.4v-102.4h102.4v102.4zM669.184 473.6l-46.080 47.104c-25.6 26.112-44.032 49.664-53.248 86.528-4.096 16.384-6.656 34.816-6.656 58.368h-102.4v-25.6c0-23.552 4.096-46.080 11.264-67.072 10.24-29.696 27.136-56.32 48.64-77.824l63.488-64.512c23.552-22.528 34.816-56.32 28.16-92.16-6.656-36.864-35.328-68.096-71.168-78.336-56.832-15.872-109.568 16.384-126.464 65.024-6.144 18.944-22.016 33.28-41.984 33.28h-15.36c-29.696 0-50.176-28.672-41.984-57.344 22.016-75.264 86.016-132.608 165.376-144.896 77.824-12.288 152.064 28.16 198.144 92.16 60.416 83.456 42.496 173.056-9.728 225.28v0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['help_solid'],
      },
      attrs: [],
      properties: {
        order: 93,
        id: 20,
        name: 'help_solid',
        prevSize: 32,
        code: 59690,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 25,
    },
    {
      icon: {
        paths: [
          'M505.829 0c132.455 0 256.973 51.816 350.549 142.888 18.307 17.817 18.878 47.282 1.276 65.813s-46.712 19.108-65.019 1.291c-76.611-74.56-178.358-116.901-286.805-116.901-228.569 0-413.86 187.552-413.86 418.909s185.292 418.909 413.86 418.909c223.997 0 406.431-180.125 413.639-405.081l0.083-5.351-47.481 47.709c-16.462 16.662-42.299 18.051-60.323 4.166l-4.709-4.166c-16.326-16.525-17.81-42.383-4.452-60.605l4.452-5.22 126.119-127.657c16.462-16.662 42.299-18.051 60.323-4.166l4.709 4.166 126.119 127.657c17.958 18.177 17.958 47.648 0 65.825-16.462 16.662-42.299 18.051-60.323 4.166l-4.709-4.166-47.677-48.311c-4.158 279.139-229.007 504.125-505.771 504.125-279.362 0-505.829-229.23-505.829-512s226.468-512 505.829-512zM511.425 204.8c25.389 0 45.97 19.933 45.97 44.521v0 255.998l106.362 141.078c14.757 20.008 9.972 47.814-10.688 62.106s-49.37 9.657-64.127-10.351v0l-114.925-155.825c-5.569-7.551-8.563-16.598-8.563-25.878v0-267.129c0-24.589 20.581-44.521 45.97-44.521z',
        ],
        attrs: [],
        grid: 0,
        tags: ['history'],
      },
      attrs: [],
      properties: {
        order: 158,
        id: 19,
        name: 'history',
        prevSize: 32,
        code: 59691,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 26,
    },
    {
      icon: {
        paths: [
          'M682.667 341.333h-48.762v-97.524c0-134.583-109.227-243.81-243.81-243.81s-243.81 109.227-243.81 243.81v97.524h-48.762c-53.638 0-97.524 43.886-97.524 97.524v487.619c0 53.638 43.886 97.524 97.524 97.524h585.143c53.638 0 97.524-43.886 97.524-97.524v-487.619c0-53.638-43.886-97.524-97.524-97.524zM390.095 780.19c-53.638 0-97.524-43.886-97.524-97.524s43.886-97.524 97.524-97.524c53.638 0 97.524 43.886 97.524 97.524s-43.886 97.524-97.524 97.524zM243.81 341.333v-97.524c0-80.945 65.341-146.286 146.286-146.286s146.286 65.341 146.286 146.286v97.524h-292.571z',
        ],
        attrs: [],
        grid: 0,
        tags: ['lock'],
      },
      attrs: [],
      properties: {
        order: 96,
        id: 15,
        name: 'lock',
        prevSize: 32,
        code: 59693,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 30,
    },
    {
      icon: {
        paths: [
          'M909.333 909.333v-218.133c10.092-19.99 29.703-29.986 58.833-29.986s47.741 9.995 55.833 29.986v218.133c0 30.222-11.555 56.889-34.667 80s-49.778 34.667-80 34.667h-794.667c-30.222 0-56.889-11.555-80-34.667s-34.667-49.778-34.667-80v-794.667c0-30.222 11.555-56.889 34.667-80s49.778-34.667 80-34.667h218.133c21.632 6.549 32.448 24.597 32.448 54.143s-10.816 49.721-32.448 60.524h-218.133v794.667h794.667zM597.333 0h426.667v426.667c-6.713 23.651-25.508 35.476-56.386 35.476s-50.305-11.825-58.281-35.476v-232l-559.808 559.808c-33.139 29.339-61.725 31.289-85.758 5.85s-21.343-54.826 8.071-88.162l557.496-557.496h-232c-19.159-7.311-28.738-26.59-28.738-57.838s9.579-50.19 28.738-56.829z',
        ],
        attrs: [],
        grid: 0,
        tags: ['new_window'],
      },
      attrs: [],
      properties: {
        order: 97,
        id: 14,
        name: 'new_window',
        prevSize: 32,
        code: 59694,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 31,
    },
    {
      icon: {
        paths: [
          'M502.858 91.429c-222.857 0-411.429 125.714-411.429 274.286 0 78.572 52.857 154.286 144.286 207.143l69.286 40-25 60c15-8.571 30-17.857 44.286-27.857l31.429-22.143 37.857 7.143c35.714 6.429 72.143 10 109.286 10 222.857 0 411.429-125.714 411.429-274.286s-188.572-274.286-411.429-274.286zM502.858 0c277.857 0 502.858 163.572 502.858 365.715s-225 365.715-502.858 365.715c-43.571 0-85.714-4.286-125.714-11.429-59.286 42.143-126.429 72.857-198.572 91.429-19.286 5-40 8.571-61.429 11.429h-2.143c-10.714 0-20.714-8.571-22.857-20.714-2.857-13.571 6.429-22.143 14.286-31.429 27.857-31.429 59.286-59.286 83.572-118.572-115.714-67.143-190-170.714-190-286.429 0-202.143 225-365.715 502.858-365.715zM1090.001 835.001c24.286 59.286 55.714 87.143 83.572 118.572 7.857 9.286 17.143 17.857 14.286 31.429-2.857 12.857-13.571 22.143-25 20.714-21.429-2.857-42.143-6.429-61.429-11.429-72.143-18.571-139.286-49.286-198.572-91.429-40 7.143-82.143 11.429-125.714 11.429-129.286 0-247.857-35.714-337.143-94.286 20.714 1.429 42.143 2.857 62.857 2.857 153.572 0 298.572-44.286 409.286-124.286 119.286-87.143 185-205 185-332.858 0-37.143-5.714-73.572-16.429-108.572 120.714 66.429 199.286 172.143 199.286 291.429 0 116.429-74.286 219.286-190 286.429z',
        ],
        attrs: [],
        grid: 0,
        tags: ['note'],
      },
      attrs: [],
      properties: {
        order: 98,
        id: 13,
        name: 'note',
        prevSize: 32,
        code: 59695,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 32,
    },
    {
      icon: {
        paths: [
          'M511.854 0c218.704 0 370.914 191.368 163.863 549.286-68.139 117.579 72.418 145.528 223.378 177.393 41.631 8.801 70.804 20.791 91.292 36.282-98.487 152.598-267.832 255.081-461.33 260.788l-17.113 0.251c-200.578-0.020-377.013-104.017-478.304-260.992 20.39-15.547 49.437-27.53 90.974-36.329 147.734-31.202 293.558-59.091 223.378-177.393-207.709-350.569-59.186-549.286 163.863-549.286z',
        ],
        attrs: [],
        grid: 0,
        tags: ['profile'],
      },
      attrs: [],
      properties: {
        order: 127,
        id: 12,
        name: 'profile',
        prevSize: 32,
        code: 59696,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 33,
    },
    {
      icon: {
        paths: [
          'M873.6 150.4c-104.32-104.32-252.16-164.48-414.72-147.84-234.88 23.68-428.16 214.4-454.4 449.28-35.2 310.4 204.8 572.16 507.52 572.16 204.16 0 379.52-119.68 461.44-291.84 20.48-42.88-10.24-92.16-57.6-92.16-23.68 0-46.080 12.8-56.32 33.92-72.32 155.52-245.76 254.080-435.2 211.84-142.080-31.36-256.64-147.2-286.72-289.28-53.76-248.32 135.040-468.48 374.4-468.48 106.24 0 200.96 44.16 270.080 113.92l-96.64 96.64c-40.32 40.32-12.16 109.44 44.8 109.44h229.76c35.2 0 64-28.8 64-64v-229.76c0-56.96-69.12-85.76-109.44-45.44l-40.96 41.6z',
        ],
        attrs: [],
        grid: 0,
        tags: ['refresh'],
      },
      attrs: [],
      properties: {
        order: 99,
        id: 11,
        name: 'refresh',
        prevSize: 32,
        code: 59697,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 34,
    },
    {
      icon: {
        paths: [
          'M711.111 625.778h-44.942l-15.929-15.36c68.267-79.644 103.538-188.302 84.196-303.787-26.738-158.151-158.72-284.444-318.009-303.787-240.64-29.582-443.164 172.942-413.582 413.582 19.342 159.289 145.636 291.271 303.787 318.009 115.484 19.342 224.142-15.929 303.787-84.196l15.36 15.929v44.942l241.778 241.778c23.324 23.324 61.44 23.324 84.764 0s23.324-61.44 0-84.764l-241.209-242.347zM369.778 625.778c-141.653 0-256-114.347-256-256s114.347-256 256-256c141.653 0 256 114.347 256 256s-114.347 256-256 256z',
        ],
        attrs: [],
        grid: 0,
        tags: ['search'],
      },
      attrs: [],
      properties: {
        order: 100,
        id: 8,
        name: 'search',
        prevSize: 32,
        code: 59698,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 37,
    },
    {
      icon: {
        paths: [
          'M982.733 403.302l0.003 0.003c27.827 27.752 45.045 66.136 45.045 108.541s-17.218 80.789-45.048 108.544l-359.834 358.4 0.007-0.006c-27.941 27.8-66.457 44.981-108.986 44.981s-81.045-17.181-108.979-44.975l-359.837-358.403c-27.827-27.752-45.045-66.136-45.045-108.541s17.218-80.789 45.048-108.544l359.834-358.4-0.007 0.006c27.941-27.8 66.457-44.981 108.986-44.981s81.045 17.181 108.979 44.975l359.834 358.4zM717.158 666.829c-0.015-13.814-5.65-26.31-14.742-35.325l-0.003-0.003-117.197-120.013 119.808-118.938c9.091-9.028 14.719-21.533 14.719-35.354s-5.628-26.326-14.716-35.351l-0.003-0.003c-9.119-9.081-21.696-14.695-35.584-14.695s-26.465 5.614-35.586 14.696l0.002-0.002-119.296 118.989-119.706-118.989c-9.178-8.947-21.736-14.465-35.582-14.465-14.229 0-27.097 5.828-36.347 15.227l-0.007 0.007c-8.955 9.081-14.485 21.56-14.485 35.331 0 14.151 5.84 26.938 15.242 36.082l0.012 0.011 119.757 118.938-119.757 118.477c-9.091 9.028-14.719 21.533-14.719 35.354s5.628 26.326 14.716 35.351l0.003 0.003c9.124 9.068 21.7 14.674 35.584 14.674s26.46-5.605 35.587-14.676l-0.003 0.003 117.248-118.989 119.194 118.989c9.124 9.068 21.7 14.674 35.584 14.674s26.46-5.605 35.587-14.676l-0.003 0.003c9.077-9.025 14.694-21.52 14.694-35.328l0-0z',
        ],
        attrs: [
          {
            fill: 'rgb(180, 4, 12)',
          },
        ],
        width: 1075,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['alert_banner_error_diamond_cross'],
        colorPermutations: {
          180412179871001: [
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(180, 4, 12)',
        },
      ],
      properties: {
        order: 13,
        id: 3,
        name: 'alert_banner_error_diamond_cross',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 6,
      setId: 0,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512 512-229.376 512-512-229.376-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6 409.6 183.808 409.6 409.6-183.808 409.6-409.6 409.6zM710.656 322.048l-301.056 301.056-96.256-96.256c-9.238-9.238-22-14.951-36.096-14.951-28.193 0-51.047 22.855-51.047 51.047 0 14.096 5.714 26.858 14.951 36.096l132.608 132.608c19.968 19.968 52.224 19.968 72.192 0l337.408-337.408c9.25-9.232 14.973-21.996 14.973-36.096s-5.723-26.864-14.972-36.095l-0.001-0.001c-19.968-19.968-52.736-19.968-72.704 0z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['alert_banner_success_check'],
        colorPermutations: {
          1804121255255255179871001: [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 14,
        id: 4,
        name: 'alert_banner_success_check',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 6,
      setId: 0,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M233.4 393.254c-53.393-53.393-139.961-53.393-193.355 0s-53.394 139.961-0 193.355l338.372 338.371c53.393 53.395 139.961 53.395 193.354 0 0.794-0.793 1.575-1.594 2.345-2.402l689.183-689.179c53.388-53.393 53.388-139.961 0-193.355-53.397-53.394-139.962-53.394-193.359 0l-594.874 594.875-241.666-241.666z',
        ],
        attrs: [
          {
            fill: 'rgb(71, 168, 23)',
          },
        ],
        width: 1303,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['check-mark-only'],
      },
      attrs: [
        {
          fill: 'rgb(71, 168, 23)',
        },
      ],
      properties: {
        order: 15,
        id: 0,
        name: 'check-mark-only',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 7,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM373.248 731.648l-183.808-183.808c-19.968-19.968-19.968-52.224 0-72.192s52.224-19.968 72.192 0l147.968 147.456 352.256-352.256c19.968-19.968 52.224-19.968 72.192 0s19.968 52.224 0 72.192l-388.608 388.608c-19.456 19.968-52.224 19.968-72.192 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['success_solid'],
      },
      attrs: [],
      properties: {
        order: 92,
        id: 4,
        name: 'success_solid',
        prevSize: 32,
        code: 59700,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 41,
    },
    {
      icon: {
        paths: [
          'M536.381 0h-195.048c-26.819 0-48.762 21.943-48.762 48.762s21.943 48.762 48.762 48.762h195.048c26.819 0 48.762-21.943 48.762-48.762s-21.943-48.762-48.762-48.762zM438.857 633.905c26.819 0 48.762-21.943 48.762-48.762v-195.048c0-26.819-21.943-48.762-48.762-48.762s-48.762 21.943-48.762 48.762v195.048c0 26.819 21.943 48.762 48.762 48.762zM781.653 311.589l36.571-36.571c18.53-18.53 19.017-49.25 0-68.267l-0.488-0.488c-19.017-19.017-49.25-18.53-68.267 0l-36.571 36.571c-75.581-60.465-170.667-96.549-274.042-96.549-234.057 0-433.006 193.097-438.857 427.154-6.339 247.71 192.122 450.56 438.857 450.56 242.834 0 438.857-196.51 438.857-438.857 0-103.375-36.084-198.461-96.061-273.554zM438.857 926.476c-188.709 0-341.333-152.625-341.333-341.333s152.625-341.333 341.333-341.333c188.709 0 341.333 152.625 341.333 341.333s-152.625 341.333-341.333 341.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['timer'],
      },
      attrs: [],
      properties: {
        order: 156,
        id: 3,
        name: 'timer',
        prevSize: 32,
        code: 59701,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 42,
    },
    {
      icon: {
        paths: [
          'M148.781 1024h907.144c92.762 0 150.588-100.593 104.207-180.706l-453.572-783.661c-46.381-80.113-162.033-80.113-208.414 0l-453.572 783.661c-46.381 80.113 11.445 180.706 104.207 180.706zM602.353 602.353c-33.129 0-60.235-27.106-60.235-60.235v-120.471c0-33.129 27.106-60.235 60.235-60.235s60.235 27.106 60.235 60.235v120.471c0 33.129-27.106 60.235-60.235 60.235zM662.588 843.294h-120.471v-120.471h120.471v120.471z',
        ],
        attrs: [],
        grid: 0,
        tags: ['warning_solid'],
      },
      attrs: [],
      properties: {
        order: 148,
        id: 1,
        name: 'warning_solid',
        prevSize: 32,
        code: 59702,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 44,
    },
    {
      icon: {
        paths: [
          'M19.71 14.82 11.84 1.06a2.09 2.09 0 0 0-3.63 0L.31 14.82A2.12 2.12 0 0 0 2.1 18h15.8a2.12 2.12 0 0 0 1.81-3.18zM11 14.5H9v-2h2v2zm0-5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2z',
          'M11 12.5H9v2h2v-2zM11 9.5v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0z',
        ],
        attrs: [
          {
            fill: 'rgb(239, 177, 21)',
          },
          {
            fill: 'rgb(7, 7, 15)',
          },
        ],
        grid: 0,
        width: 20,
        height: 18,
        tags: ['warning_solid_black'],
      },
      attrs: [],
      properties: {
        order: 148,
        id: 1,
        name: 'warning_solid_black',
        prevSize: 32,
        code: 59702,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 44,
    },
    {
      icon: {
        paths: [
          'M637.483 838.272c0 55.467-56.107 100.395-125.483 100.395s-125.483-44.885-125.483-100.395zM594.816 85.333c23.564 0 42.667 19.103 42.667 42.667v0 15.061c0 0.018 0 0.040 0 0.061 0 5.262-0.954 10.3-2.699 14.952l0.097-0.294c122.283 42.581 208.981 147.328 208.981 269.739v249.088l94.805 83.029v41.515h-853.333v-41.515l94.805-83.029v-249.088c0-122.453 86.699-227.157 209.024-269.739-1.675-4.363-2.645-9.409-2.645-14.683 0-0.013 0-0.026 0-0.039l-0 0.002v-15.061c0-23.564 19.103-42.667 42.667-42.667v0h165.632zM512 203.819c-130.859 0-237.056 95.573-237.056 213.333v298.667h474.112v-298.667c0-117.76-106.24-213.333-237.056-213.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['alert-bell'],
      },
      attrs: [],
      properties: {
        order: 87,
        id: 11,
        name: 'alert-bell',
        prevSize: 32,
        code: 59720,
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 14,
    },
    {
      icon: {
        paths: [
          'M512 341.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM512 426.667c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333zM512 682.667c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['overflow-menu-vertical'],
      },
      attrs: [],
      properties: {
        order: 111,
        id: 5,
        name: 'overflow-menu-vertical',
        prevSize: 32,
        code: 59724,
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 20,
    },
    {
      icon: {
        paths: [
          'M512 42.667c84.523 0 162.773 21.12 234.667 63.403 71.35 42.037 129.227 99.914 170.057 169.055l1.207 2.209c39.844 66.253 63.412 146.217 63.412 231.686 0 1.048-0.004 2.095-0.011 3.142l0.001-0.161c0 84.523-21.12 162.773-63.403 234.667-42.037 71.35-99.914 129.227-169.055 170.057l-2.209 1.207c-66.253 39.844-146.217 63.412-231.686 63.412-1.048 0-2.095-0.004-3.142-0.011l0.161 0.001c-84.523 0-162.773-21.12-234.667-63.403-71.35-42.037-129.227-99.914-170.057-169.055l-1.207-2.209c-39.844-66.253-63.412-146.217-63.412-231.686 0-1.048 0.004-2.095 0.011-3.142l-0.001 0.161c0-84.523 21.12-162.773 63.403-234.667 42.037-71.35 99.914-129.227 169.055-170.057l2.209-1.207c66.253-39.844 146.217-63.412 231.686-63.412 1.048 0 2.095 0.004 3.142 0.011l-0.161-0.001zM853.333 341.333c-17.853-39.11-41.575-72.459-70.451-100.534l-0.077-0.074c-28.574-27.819-61.611-51.244-97.898-69.064l-2.241-0.994c24.363 47.915 42.368 104.789 53.973 170.667h116.693zM512 128c-20.309 0-42.667 18.432-67.029 55.253-27.093 41.899-47.445 94.592-60.971 158.080h256c-13.525-63.488-33.877-116.181-60.971-158.080-24.363-36.821-46.72-55.253-67.029-55.253zM128 512c0 28.459 2.773 56.875 8.32 85.333h131.2c-3.584-68.821-3.584-115.413 0-170.667h-131.2c-5.273 25.647-8.301 55.131-8.32 85.319l-0 0.015zM170.667 682.667c17.408 38.315 40.96 71.851 70.528 100.608 28.574 27.819 61.611 51.244 97.898 69.064l2.241 0.994c-24.363-47.915-42.368-104.789-53.973-170.667h-116.693zM287.36 341.333c11.605-65.877 29.611-122.752 53.973-170.667-38.528 18.815-71.565 42.24-100.223 70.141l0.084-0.082c-28.953 28.149-52.675 61.498-69.688 98.566l-0.84 2.042h116.693zM512 896c20.309 0 42.667-18.432 67.029-55.253 27.093-41.899 47.445-94.592 60.971-158.080h-256c13.525 63.488 33.877 116.181 60.971 158.080 24.363 36.821 46.72 55.253 67.029 55.253zM653.739 597.333c9.216-37.803 9.216-130.901 0-170.667h-285.525c-7.68 38.272-7.68 130.389 0 170.667h285.525zM682.667 853.333c38.528-18.815 71.565-42.24 100.223-70.141l-0.084 0.082c28.953-28.149 52.675-61.498 69.688-98.566l0.84-2.042h-116.693c-11.605 65.877-29.611 122.752-53.973 170.667zM749.227 597.333h138.453c5.547-28.459 8.32-56.875 8.32-85.333s-2.773-56.875-8.32-85.333h-138.453c2.773 31.275 4.139 59.733 4.139 85.333s-1.365 54.059-4.139 85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['website'],
      },
      attrs: [],
      properties: {
        order: 103,
        id: 2,
        name: 'website',
        prevSize: 32,
        code: 59725,
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 23,
    },
    {
      icon: {
        paths: [
          'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667 426.667-191.147 426.667-426.667-191.147-426.667-426.667-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333 0-78.933 26.88-151.467 72.107-209.067l478.293 478.293c-57.6 45.227-130.133 72.107-209.067 72.107zM781.227 721.067l-478.293-478.293c57.6-45.227 130.133-72.107 209.067-72.107 188.587 0 341.333 152.747 341.333 341.333 0 78.933-26.88 151.467-72.107 209.067z',
        ],
        attrs: [],
        grid: 0,
        tags: ['block'],
      },
      attrs: [],
      properties: {
        order: 120,
        id: 43,
        name: 'block',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M652.8 738.133c17.067-17.067 17.067-42.667 0-59.733l-166.4-166.4 166.4-166.4c17.067-17.067 17.067-42.667 0-59.733s-42.667-17.067-59.733 0l-196.267 196.267c-17.067 17.067-17.067 42.667 0 59.733l196.267 196.267c17.067 17.067 42.667 17.067 59.733 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['chevron_left'],
      },
      attrs: [],
      properties: {
        order: 116,
        id: 40,
        name: 'chevron_left',
        prevSize: 32,
        code: 59652,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 4,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512 512-229.376 512-512-229.376-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6 409.6 183.808 409.6 409.6-183.808 409.6-409.6 409.6zM710.656 322.048l-301.056 301.056-96.256-96.256c-9.238-9.238-22-14.951-36.096-14.951-28.193 0-51.047 22.855-51.047 51.047 0 14.096 5.714 26.858 14.951 36.096l132.608 132.608c19.968 19.968 52.224 19.968 72.192 0l337.408-337.408c9.25-9.232 14.973-21.996 14.973-36.096s-5.723-26.864-14.972-36.095l-0.001-0.001c-19.968-19.968-52.736-19.968-72.704 0z',
        ],
        attrs: [
          {
            fill: 'rgb(79, 87, 100)',
            opacity: 0.87,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['check-mark-circle'],
      },
      attrs: [
        {
          fill: 'rgb(79, 87, 100)',
          opacity: 0.87,
        },
      ],
      properties: {
        order: 2,
        id: 0,
        name: 'check-mark-circle',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M853.333 199.111c94.257 0 170.667 76.41 170.667 170.667v284.444c0 94.257-76.41 170.667-170.667 170.667h-455.111c-94.257 0-170.667-76.41-170.667-170.667v-113.778h-227.556v-56.889h227.556v-113.778c0-94.257 76.41-170.667 170.667-170.667h455.111zM284.444 654.222c0 62.838 50.94 113.778 113.778 113.778h455.111c62.838 0 113.778-50.94 113.778-113.778v-284.444c0-62.838-50.94-113.778-113.778-113.778h-455.111c-62.838 0-113.778 50.94-113.778 113.778v113.778l201.949 0.033c13.165-64.933 70.566-113.81 139.384-113.81 78.547 0 142.222 63.675 142.222 142.222s-63.675 142.222-142.222 142.222c-68.797 0-126.185-48.848-139.372-113.753l-201.961-0.025v113.778z',
        ],
        attrs: [],
        grid: 0,
        tags: ['common-node'],
      },
      attrs: [],
      properties: {
        order: 149,
        id: 38,
        name: 'common-node',
        prevSize: 32,
        code: 59654,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 6,
    },
    {
      icon: {
        paths: [
          'M853.333 199.111c94.257 0 170.667 76.41 170.667 170.667v284.444c0 94.257-76.41 170.667-170.667 170.667h-455.111c-94.257 0-170.667-76.41-170.667-170.667v-113.778h-227.556v-56.889h227.556v-113.778c0-94.257 76.41-170.667 170.667-170.667h455.111zM625.778 369.778c-78.547 0-142.222 63.675-142.222 142.222s63.675 142.222 142.222 142.222c78.547 0 142.222-63.675 142.222-142.222s-63.675-142.222-142.222-142.222z',
        ],
        attrs: [],
        grid: 0,
        tags: ['common-node-selected'],
      },
      attrs: [],
      properties: {
        order: 112,
        id: 37,
        name: 'common-node-selected',
        prevSize: 32,
        code: 59655,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 7,
    },
    {
      icon: {
        paths: [
          'M170.667 256h-85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333v-85.333h-597.333v-597.333zM853.333 85.333h-512c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM810.667 469.333h-170.667v170.667h-85.333v-170.667h-170.667v-85.333h170.667v-170.667h85.333v170.667h170.667v85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['duplicate'],
      },
      attrs: [],
      properties: {
        order: 157,
        id: 35,
        name: 'duplicate',
        prevSize: 32,
        code: 59657,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 9,
    },
    {
      icon: {
        paths: [
          'M563.2 665.6v102.4h-102.4v-102.4h102.4zM512 256c28.16 0 51.2 23.040 51.2 51.2v204.8c0 28.16-23.040 51.2-51.2 51.2s-51.2-23.040-51.2-51.2v-204.8c0-28.16 23.040-51.2 51.2-51.2zM511.488 0c-282.624 0-511.488 229.376-511.488 512s228.864 512 511.488 512c283.136 0 512.512-229.376 512.512-512s-229.376-512-512.512-512zM512 921.6c-226.304 0-409.6-183.296-409.6-409.6s183.296-409.6 409.6-409.6 409.6 183.296 409.6 409.6-183.296 409.6-409.6 409.6z',
        ],
        attrs: [],
        grid: 0,
        tags: ['alert_outline'],
      },
      attrs: [],
      properties: {
        order: 88,
        id: 34,
        name: 'alert_outline',
        prevSize: 32,
        code: 59658,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 10,
    },
    {
      icon: {
        paths: [
          'M512 725.333c-25.6 0-42.667-21.333-42.667-42.667v-170.667c0-25.6 17.067-42.667 42.667-42.667s42.667 17.067 42.667 42.667v170.667c0 21.333-17.067 42.667-42.667 42.667zM512 938.667c234.667 0 426.667-192 426.667-426.667s-192-426.667-426.667-426.667c-234.667 0-426.667 192-426.667 426.667s192 426.667 426.667 426.667zM512 170.667c187.733 0 341.333 153.6 341.333 341.333s-153.6 341.333-341.333 341.333-341.333-153.6-341.333-341.333 153.6-341.333 341.333-341.333zM469.333 298.667h85.333v85.333h-85.333v-85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['info_outline'],
      },
      attrs: [],
      properties: {
        order: 89,
        id: 30,
        name: 'info_outline',
        prevSize: 32,
        code: 59662,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 14,
    },
    {
      icon: {
        paths: [
          'M608.768 343.040l-96.768 96.768-96.768-96.768c-9.238-9.238-22-14.951-36.096-14.951-28.193 0-51.047 22.855-51.047 51.047 0 14.096 5.714 26.858 14.951 36.096l96.768 96.768-96.768 96.768c-9.238 9.238-14.951 22-14.951 36.096 0 28.193 22.855 51.047 51.047 51.047 14.096 0 26.858-5.714 36.096-14.951l96.768-96.768 96.768 96.768c9.238 9.238 22 14.951 36.096 14.951 28.193 0 51.047-22.855 51.047-51.047 0-14.096-5.714-26.858-14.951-36.096l-96.768-96.768 96.768-96.768c9.25-9.232 14.973-21.996 14.973-36.096s-5.723-26.864-14.972-36.095l-0.001-0.001c-19.968-19.456-52.736-19.456-72.192 0zM512 0c-283.136 0-512 228.864-512 512s228.864 512 512 512 512-228.864 512-512-228.864-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6 409.6 183.808 409.6 409.6-183.808 409.6-409.6 409.6z',
        ],
        attrs: [
          {
            fill: 'rgb(79, 87, 100)',
            opacity: 0.87,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['remove_circle_outlined'],
      },
      attrs: [
        {
          fill: 'rgb(79, 87, 100)',
          opacity: 0.87,
        },
      ],
      properties: {
        order: 5,
        id: 0,
        name: 'remove_circle_outlined',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1024 0v708.923c0 174.012-141.065 315.077-315.077 315.077h-708.923v-708.923c0-174.012 141.065-315.077 315.077-315.077h708.923zM496.046 214.231c-43.334 0-80.32 6.538-110.962 19.615s-54.102 32.115-70.385 57.115c-16.282 25-24.423 51.859-24.423 80.577 0 44.616 17.308 82.436 51.923 113.462 24.615 22.051 67.436 40.641 128.462 55.769 36.895 9.174 63.474 16.176 79.739 21.007v0l11.415 3.609c19.487 6.923 33.141 15.064 40.961 24.423s11.731 20.705 11.731 34.038c0 20.769-9.295 38.91-27.885 54.423s-46.218 23.269-82.885 23.269c-34.616 0-62.115-8.718-82.5-26.154s-33.91-44.743-40.577-81.923v0l-110.769 10.769c7.436 63.077 30.256 111.090 68.462 144.039s92.948 49.423 164.231 49.423c48.975 0 89.872-6.859 122.692-20.577s58.205-34.679 76.154-62.885c17.949-28.205 26.923-58.461 26.923-90.769 0-35.641-7.5-65.577-22.5-89.808s-35.769-43.333-62.308-57.308c-26.539-13.974-67.5-27.5-122.885-40.577v0l-16-3.908c-46.154-11.677-75.692-22.938-88.615-33.785-11.282-9.487-16.923-20.897-16.923-34.231 0-14.615 6.026-26.282 18.077-35 18.718-13.59 44.615-20.385 77.692-20.385 32.052 0 56.090 6.346 72.115 19.038s26.474 33.525 31.346 62.5v0l113.846-5c-1.795-51.795-20.577-93.205-56.346-124.231s-89.038-46.538-159.808-46.538z',
        ],
        attrs: [],
        grid: 0,
        tags: ['slot-copy'],
      },
      attrs: [],
      properties: {
        order: 101,
        id: 24,
        name: 'slot-copy',
        prevSize: 32,
        code: 59668,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 20,
    },
    {
      icon: {
        paths: [
          'M512 192c-213.333 0-395.52 132.693-469.333 320 73.813 187.307 256 320 469.333 320s395.52-132.693 469.333-320c-73.813-187.307-256-320-469.333-320zM512 725.333c-117.76 0-213.333-95.573-213.333-213.333s95.573-213.333 213.333-213.333 213.333 95.573 213.333 213.333-95.573 213.333-213.333 213.333zM512 384c-70.827 0-128 57.173-128 128s57.173 128 128 128 128-57.173 128-128-57.173-128-128-128z',
        ],
        attrs: [],
        grid: 0,
        tags: ['view'],
      },
      attrs: [],
      properties: {
        order: 86,
        id: 22,
        name: 'view',
        prevSize: 32,
        code: 59670,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 22,
    },
    {
      icon: {
        paths: [
          'M371.627 499.627l110.507 110.507c16.64 16.64 43.52 16.64 60.16 0l110.507-110.507c26.88-26.88 7.68-72.96-30.293-72.96h-221.013c-37.973 0-56.747 46.080-29.867 72.96z',
        ],
        attrs: [],
        grid: 0,
        tags: ['caret_drop_down'],
      },
      attrs: [],
      properties: {
        order: 104,
        id: 20,
        name: 'caret_drop_down',
        prevSize: 32,
        code: 59672,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 24,
    },
    {
      icon: {
        paths: [
          'M371.627 524.373l110.507-110.507c16.64-16.64 43.52-16.64 60.16 0l110.507 110.507c26.88 26.88 7.68 72.96-30.293 72.96h-221.013c-37.973 0-56.747-46.080-29.867-72.96z',
        ],
        attrs: [],
        grid: 0,
        tags: ['caret_drop_up'],
      },
      attrs: [],
      properties: {
        order: 105,
        id: 19,
        name: 'caret_drop_up',
        prevSize: 32,
        code: 59673,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 25,
    },
    {
      icon: {
        paths: [
          'M524.373 371.627l-110.507 110.507c-16.64 16.64-16.64 43.52 0 60.16l110.507 110.507c26.88 26.88 72.96 7.68 72.96-30.293v-221.013c0-37.973-46.080-56.747-72.96-29.867z',
        ],
        attrs: [],
        grid: 0,
        tags: ['caret_drop_left'],
      },
      attrs: [],
      properties: {
        order: 106,
        id: 18,
        name: 'caret_drop_left',
        prevSize: 32,
        code: 59674,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 26,
    },
    {
      icon: {
        paths: [
          'M499.627 652.373l110.507-110.507c16.64-16.64 16.64-43.52 0-60.16l-110.507-110.507c-26.88-26.453-72.96-7.68-72.96 30.293v220.587c0 38.4 46.080 57.173 72.96 30.293z',
        ],
        attrs: [],
        grid: 0,
        tags: ['caret_drop_right'],
      },
      attrs: [],
      properties: {
        order: 107,
        id: 17,
        name: 'caret_drop_right',
        prevSize: 32,
        code: 59675,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 27,
    },
    {
      icon: {
        paths: [
          'M512 0c-283.136 0-512 228.864-512 512s228.864 512 512 512 512-228.864 512-512-228.864-512-512-512zM732.16 732.16c-9.232 9.25-21.996 14.973-36.096 14.973s-26.864-5.723-36.095-14.972l-0.001-0.001-147.968-147.968-147.968 147.968c-9.238 9.238-22 14.951-36.096 14.951-28.193 0-51.047-22.855-51.047-51.047 0-14.096 5.714-26.858 14.951-36.096l147.968-147.968-147.968-147.968c-9.238-9.238-14.951-22-14.951-36.096 0-28.193 22.855-51.047 51.047-51.047 14.096 0 26.858 5.714 36.096 14.951l147.968 147.968 147.968-147.968c9.238-9.238 22-14.951 36.096-14.951 28.193 0 51.047 22.855 51.047 51.047 0 14.096-5.714 26.858-14.951 36.096l-147.968 147.968 147.968 147.968c19.456 19.456 19.456 52.224 0 72.192z',
        ],
        attrs: [
          {
            fill: 'rgb(79, 87, 100)',
            opacity: 0.87,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['remove_circle'],
      },
      attrs: [
        {
          fill: 'rgb(79, 87, 100)',
          opacity: 0.87,
        },
      ],
      properties: {
        order: 6,
        id: 0,
        name: 'remove_circle',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M128 744.96v129.707c0 11.947 9.387 21.333 21.333 21.333h129.707c5.547 0 11.093-2.133 14.933-6.4l465.92-465.493-160-160-465.493 465.493c-4.267 4.267-6.4 9.387-6.4 15.36zM883.627 300.373c16.64-16.64 16.64-43.52 0-60.16l-99.84-99.84c-16.64-16.64-43.52-16.64-60.16 0l-78.080 78.080 160 160 78.080-78.080z',
        ],
        attrs: [],
        grid: 0,
        tags: ['edit'],
      },
      attrs: [],
      properties: {
        order: 122,
        id: 11,
        name: 'edit',
        prevSize: 32,
        code: 59681,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 32,
    },
    {
      icon: {
        paths: [
          'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667 426.667-191.147 426.667-426.667-191.147-426.667-426.667-426.667zM512 554.667c-23.467 0-42.667-19.2-42.667-42.667v-170.667c0-23.467 19.2-42.667 42.667-42.667s42.667 19.2 42.667 42.667v170.667c0 23.467-19.2 42.667-42.667 42.667zM554.667 725.333h-85.333v-85.333h85.333v85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['alert_solid'],
      },
      attrs: [],
      properties: {
        order: 90,
        id: 10,
        name: 'alert_solid',
        prevSize: 32,
        code: 59682,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 33,
    },
    {
      icon: {
        paths: [
          'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667 426.667-191.147 426.667-426.667-191.147-426.667-426.667-426.667zM554.667 810.667h-85.333v-85.333h85.333v85.333zM642.987 480l-38.4 39.253c-21.333 21.76-36.693 41.387-44.373 72.107-3.413 13.653-5.547 29.013-5.547 48.64h-85.333v-21.333c0-19.627 3.413-38.4 9.387-55.893 8.533-24.747 22.613-46.933 40.533-64.853l52.907-53.76c19.627-18.773 29.013-46.933 23.467-76.8-5.547-30.72-29.44-56.747-59.307-65.28-47.36-13.227-91.307 13.653-105.387 54.187-5.12 15.787-18.347 27.733-34.987 27.733h-12.8c-24.747 0-41.813-23.893-34.987-47.787 18.347-62.72 71.68-110.507 137.813-120.747 64.853-10.24 126.72 23.467 165.12 76.8 50.347 69.547 35.413 144.213-8.107 187.733z',
        ],
        attrs: [],
        grid: 0,
        tags: ['help_solid'],
      },
      attrs: [],
      properties: {
        order: 146,
        id: 9,
        name: 'help_solid',
        prevSize: 32,
        code: 59683,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 34,
    },
    {
      icon: {
        paths: [
          'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667 426.667-191.147 426.667-426.667-191.147-426.667-426.667-426.667zM512 725.333c-23.467 0-42.667-19.2-42.667-42.667v-170.667c0-23.467 19.2-42.667 42.667-42.667s42.667 19.2 42.667 42.667v170.667c0 23.467-19.2 42.667-42.667 42.667zM554.667 384h-85.333v-85.333h85.333v85.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['info_solid'],
      },
      attrs: [],
      properties: {
        order: 91,
        id: 7,
        name: 'info_solid',
        prevSize: 32,
        code: 59685,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 36,
    },
    {
      icon: {
        paths: [
          'M140.516 1024h856.747c87.609 0 142.222-95.004 98.418-170.667l-428.373-740.124c-43.804-75.662-153.031-75.662-196.836 0l-428.373 740.124c-43.804 75.662 10.809 170.667 98.418 170.667zM568.889 625.778c-31.289 0-56.889-25.6-56.889-56.889v-113.778c0-31.289 25.6-56.889 56.889-56.889s56.889 25.6 56.889 56.889v113.778c0 31.289-25.6 56.889-56.889 56.889zM625.778 853.333h-113.778v-113.778h113.778v113.778z',
        ],
        attrs: [
          {
            fill: 'rgb(79, 87, 100)',
            opacity: 0.87,
          },
        ],
        width: 1138,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['alert_exclamation_triangle_solid'],
      },
      attrs: [
        {
          fill: 'rgb(79, 87, 100)',
          opacity: 0.87,
        },
      ],
      properties: {
        order: 4,
        id: 0,
        name: 'alert_exclamation_triangle_solid',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M346.453 396.373l165.547 165.547 165.547-165.547c16.64-16.64 43.52-16.64 60.16 0s16.64 43.52 0 60.16l-195.84 195.84c-16.64 16.64-43.52 16.64-60.16 0l-195.84-195.84c-16.64-16.64-16.64-43.52 0-60.16 16.64-16.213 43.947-16.64 60.587 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['chevron_down'],
      },
      attrs: [],
      properties: {
        order: 113,
        id: 6,
        name: 'chevron_down',
        prevSize: 32,
        code: 59686,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 37,
    },
    {
      icon: {
        paths: [
          'M346.453 627.627l165.547-165.547 165.547 165.547c16.64 16.64 43.52 16.64 60.16 0s16.64-43.52 0-60.16l-195.84-195.84c-16.64-16.64-43.52-16.64-60.16 0l-195.84 195.84c-16.64 16.64-16.64 43.52 0 60.16 16.64 16.213 43.947 16.64 60.587 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['chevron_up'],
      },
      attrs: [],
      properties: {
        order: 114,
        id: 5,
        name: 'chevron_up',
        prevSize: 32,
        code: 59687,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 38,
    },
    {
      icon: {
        paths: [
          'M396.373 286.293c-16.64 16.64-16.64 43.52 0 60.16l165.547 165.547-165.547 165.547c-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0l195.84-195.84c16.64-16.64 16.64-43.52 0-60.16l-195.84-195.84c-16.213-16.213-43.52-16.213-60.16 0.427z',
        ],
        attrs: [],
        grid: 0,
        tags: ['chevron_right'],
      },
      attrs: [],
      properties: {
        order: 115,
        id: 13,
        name: 'chevron_right',
        prevSize: 32,
        code: 59679,
      },
      setIdx: 3,
      setId: 0,
      iconIdx: 39,
    },
    {
      icon: {
        paths: [
          'M972.8 51.931c-28.526-28.526-74.606-28.526-103.131 0l-357.669 356.937-357.669-357.669c-28.526-28.526-74.606-28.526-103.131 0s-28.526 74.606 0 103.131l357.669 357.669-357.669 357.669c-28.526 28.526-28.526 74.606 0 103.131s74.606 28.526 103.131 0l357.669-357.669 357.669 357.669c28.526 28.526 74.606 28.526 103.131 0s28.526-74.606 0-103.131l-357.669-357.669 357.669-357.669c27.794-27.794 27.794-74.606 0-102.4z',
        ],
        attrs: [],
        grid: 0,
        tags: ['cancel'],
      },
      attrs: [],
      properties: {
        order: 165,
        id: 38,
        name: 'cancel',
        prevSize: 32,
        code: 59651,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 7,
    },
    {
      icon: {
        paths: [
          'M471.040 578.56c0-15.36-15.36-30.72-30.72-30.72h-256c-30.72 0-40.96 35.84-20.48 56.32l87.040 87.040-199.68 199.68c-20.48 20.48-20.48 56.32 0 76.8s56.32 20.48 76.8 0l199.68-199.68c5.12 5.12 5.12 5.12 5.12 5.12l81.92 81.92c20.48 20.48 56.32 5.12 56.32-20.48v-256z M547.84 450.56c0 15.36 15.36 30.72 30.72 30.72h256c30.72 0 40.96-35.84 20.48-56.32l-87.040-87.040 199.68-199.68c20.48-20.48 20.48-56.32 0-76.8s-56.32-20.48-76.8 0l-199.68 199.68c0 0-5.12-5.12-5.12-5.12l-81.92-81.92c-20.48-20.48-56.32-5.12-56.32 20.48v256z',
        ],
        attrs: [],
        grid: 0,
        tags: ['collapse'],
      },
      attrs: [],
      properties: {
        order: 168,
        id: 29,
        name: 'collapse',
        prevSize: 32,
        code: 59661,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 16,
    },
    {
      icon: {
        paths: [
          'M0 0v307.2h0.533l-0.533 0.512 213.333 204.288-213.333 204.8 0.533 0.512h-0.533v306.688h640v-306.688h-0.533l0.533-0.512-213.333-204.8 213.333-204.288-0.533-0.512h0.533v-307.2h-640zM533.333 742.4v179.2c-142.222-59.733-213.333-89.6-213.333-89.6s-71.111 29.867-213.333 89.6v-179.2l213.333-204.8 213.333 204.8zM320 281.6h-213.333v-179.2h426.667v179.2h-213.333z M320 448v480',
        ],
        attrs: [],
        grid: 0,
        tags: ['delay_timer'],
      },
      attrs: [],
      properties: {
        order: 164,
        id: 28,
        name: 'delay_timer',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 17,
    },
    {
      icon: {
        paths: [
          'M35.84 952.32c0 15.36 15.36 30.72 30.72 30.72h256c30.72 0 40.96-35.84 20.48-56.32l-87.040-87.040 199.68-199.68c20.48-20.48 20.48-56.32 0-76.8s-56.32-20.48-76.8 0l-199.68 199.68c-5.12-5.12-5.12-5.12-5.12-5.12l-81.92-81.92c-20.48-20.48-56.32-5.12-56.32 20.48v256z M988.16 76.8c0-15.36-15.36-30.72-30.72-30.72h-256c-30.72 0-40.96 35.84-20.48 56.32l87.040 87.040-204.8 199.68c-20.48 20.48-20.48 56.32 0 76.8s56.32 20.48 76.8 0l199.68-199.68c5.12 5.12 5.12 5.12 5.12 5.12l87.040 87.040c20.48 20.48 56.32 5.12 56.32-20.48v-261.12z',
        ],
        attrs: [],
        grid: 0,
        tags: ['expand'],
      },
      attrs: [],
      properties: {
        order: 166,
        id: 25,
        name: 'expand',
        prevSize: 32,
        code: 59665,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 20,
    },
    {
      icon: {
        paths: [
          'M0 658.286l365.714 365.714 365.714-365.714z M731.429 365.714l-365.714-365.714-365.714 365.714z',
        ],
        attrs: [],
        grid: 0,
        tags: ['sort'],
      },
      attrs: [],
      properties: {
        order: 167,
        id: 6,
        name: 'sort',
        prevSize: 32,
        code: 59699,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 39,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6c225.792 0 409.6 183.808 409.6 409.6s-183.808 409.6-409.6 409.6zM710.656 322.048l-301.056 301.056-96.256-96.256c-19.968-19.968-52.224-19.968-72.192 0s-19.968 52.224 0 72.192l132.608 132.608c19.968 19.968 52.224 19.968 72.192 0l337.408-337.408c19.968-19.968 19.968-52.224 0-72.192s-52.736-19.968-72.704 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['success_outline'],
      },
      attrs: [],
      properties: {
        order: 162,
        id: 5,
        name: 'success_outline',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 40,
    },
    {
      icon: {
        paths: [
          'M512 645.333l103.467 65.493c18.944 11.989 42.112-5.76 37.12-28.16l-27.392-123.136 91.477-82.987c16.725-15.104 7.723-43.819-14.208-45.653l-120.405-10.667-47.104-116.352c-3.601-9.356-12.517-15.875-22.955-15.875s-19.354 6.519-22.898 15.707l-0.057 0.168-47.104 116.053-120.405 10.709c-21.931 1.835-30.933 30.549-14.208 45.653l91.477 82.944-27.435 123.136c-4.949 22.443 18.219 40.192 37.163 28.16l103.467-65.152z M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667 426.667-191.147 426.667-426.667-191.147-426.667-426.667-426.667zM512 853.333c-188.16 0-341.333-153.173-341.333-341.333s153.173-341.333 341.333-341.333 341.333 153.173 341.333 341.333-153.173 341.333-341.333 341.333z',
        ],
        attrs: [],
        grid: 0,
        tags: ['favorites'],
      },
      attrs: [],
      properties: {
        order: 161,
        id: 8,
        name: 'favorites',
        prevSize: 32,
        code: 59650,
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 17,
    },
    {
      icon: {
        paths: [
          'M128 85.333h768c23.564 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667h-768c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667z M128 597.333h768c23.564 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667h-768c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667z M128 853.333h512c23.564 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667h-512c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667z M128 341.333h512c23.564 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667h-512c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667z',
        ],
        attrs: [],
        grid: 0,
        tags: ['list'],
      },
      attrs: [],
      properties: {
        order: 163,
        id: 7,
        name: 'list',
        prevSize: 32,
        code: 59723,
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 18,
    },
    {
      icon: {
        paths: [
          'M739.499 0h-739.499v1024h796.444v-278.073h-113.778v164.295h-568.889v-796.444h568.889v225.849h113.778v-339.627h-56.889-0.057zM524.231 541.867l284.444 164.238v-135.794h597.333v-56.889h-597.333v-135.68l-284.444 164.181z',
        ],
        attrs: [
          {
            opacity: 0.4,
          },
        ],
        width: 1422,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['batch_import'],
        colorPermutations: {
          1511511511255255255179871001: [{}],
        },
      },
      attrs: [
        {
          opacity: 0.4,
        },
      ],
      properties: {
        order: 19,
        id: 6,
        name: 'batch_import',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 4,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M602.51 119.791l301.699 301.699c49.987 49.987 49.987 131.032 0 181.019l-301.699 301.699c-49.987 49.987-131.032 49.987-181.019 0l-301.699-301.699c-49.987-49.987-49.987-131.032 0-181.019l301.699-301.699c49.987-49.987 131.032-49.987 181.019 0z',
        ],
        attrs: [],
        grid: 0,
        tags: ['workflow_action'],
      },
      attrs: [],
      properties: {
        order: 170,
        id: 1,
        name: 'workflow_action',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M602.496 119.808l301.696 301.653c23.168 23.164 37.498 55.167 37.498 90.517s-14.33 67.353-37.498 90.517l-301.654 301.696c-23.164 23.168-55.167 37.498-90.517 37.498s-67.353-14.33-90.517-37.498l-301.696-301.654c-23.168-23.164-37.498-55.167-37.498-90.517s14.33-67.353 37.498-90.517l301.654-301.696c23.164-23.168 55.167-37.498 90.517-37.498s67.353 14.33 90.517 37.498l0 0zM553.728 374.827l-0.512 90.368-0.043 5.632-223.019-1.536c-22.571 0.171-42.453 20.053-42.581 42.624s19.499 42.24 42.112 42.069l220.16-1.28v5.632l-0.555 96c-0.128 22.613 28.032 33.707 42.24 19.499l144.811-144.811c4.267-4.267 10.795-10.667 10.837-17.024 0-5.291-4.437-10.539-8.405-14.549l-142.592-142.635c-16.811-16.811-42.325-2.56-42.453 20.053z',
        ],
        attrs: [],
        grid: 0,
        tags: ['workflow_action_arrow'],
      },
      attrs: [],
      properties: {
        order: 169,
        id: 0,
        name: 'workflow_action_arrow',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M731.75 0l497.050 512-497.050 512-117.35-120.832 381.747-391.168-381.747-391.168 117.35-120.832zM219.75 0l497.050 512-497.050 512-117.35-120.832 381.747-391.168-381.747-391.168 117.35-120.832z',
        ],
        attrs: [],
        width: 1229,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['icons-expand-collapse-double-chevron'],
      },
      attrs: [],
      properties: {
        order: 3,
        id: 0,
        name: 'icons-expand-collapse-double-chevron',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M768 870.4h-716.8v-716.8h716.8v716.8zM665.6 665.6h-512v102.4h512v-102.4zM665.6 460.8h-512v102.4h512v-102.4zM665.6 256h-512v102.4h512v-102.4z',
        ],
        attrs: [{ fill: 'rgb(30, 122, 255)' }],
        width: 819,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['table'],
        colorPermutations: { '30122255179871001': [{ f: 1 }] },
      },
      attrs: [{ fill: 'rgb(30, 122, 255)' }],
      properties: {
        order: 6,
        id: 2,
        name: 'table',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M768 1024h-307.2v-102.4h-307.2v-614.4h-102.4v-307.2h307.2v307.2h-102.4v102.4h204.8v-102.4h307.2v307.2h-307.2v-102.4h-204.8v307.2h204.8v-102.4h307.2v307.2zM665.6 819.2h-102.4v102.4h102.4v-102.4zM665.6 409.6h-102.4v102.4h102.4v-102.4z',
        ],
        attrs: [{ fill: 'rgb(30, 122, 255)' }],
        width: 819,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['diagram'],
        colorPermutations: { '30122255179871001': [{ f: 1 }] },
      },
      attrs: [{ fill: 'rgb(30, 122, 255)' }],
      properties: {
        order: 5,
        id: 1,
        name: 'diagram',
        prevSize: 32,
        code: 59649,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M886.517 554.667v331.85h-663.702v-331.85h-94.815v331.85c0 52.15 42.667 94.817 94.815 94.817h663.702c52.15 0 94.817-42.667 94.817-94.817v-331.85h-94.817zM602.072 586.428l122.789-122.309 66.844 66.844-237.039 237.037-237.037-237.037 66.844-66.844 122.786 122.309v-458.428h94.813v458.428z',
        ],
        attrs: [{ fill: 'rgb(79, 87, 100)', opacity: 0.87 }],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['apply-pto-template'],
      },
      attrs: [{ fill: 'rgb(79, 87, 100)', opacity: 0.87 }],
      properties: {
        order: 6,
        id: 2,
        name: 'apply-pto-template',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 1,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 768c-30.72 0-51.2-25.6-51.2-51.2v-204.8c0-30.72 20.48-51.2 51.2-51.2s51.2 20.48 51.2 51.2v204.8c0 25.6-20.48 51.2-51.2 51.2zM512 1024c281.6 0 512-230.4 512-512s-230.4-512-512-512-512 230.4-512 512 230.4 512 512 512zM512 102.4c225.28 0 409.6 184.32 409.6 409.6s-184.32 409.6-409.6 409.6c-225.28 0-409.6-184.32-409.6-409.6s184.32-409.6 409.6-409.6zM460.8 256h102.4v102.4h-102.4v-102.4z',
        ],
        attrs: [{ fill: 'rgb(30, 122, 255)' }],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['info-icon-outlined'],
      },
      attrs: [{ fill: 'rgb(30, 122, 255)' }],
      properties: {
        order: 5,
        id: 0,
        name: 'info-icon-outlined',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 5,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 0c-282.761 0-512 229.239-512 512s229.239 512 512 512c282.761 0 512-229.239 512-512s-229.239-512-512-512zM512 68.267c245.077 0 443.733 198.656 443.733 443.733s-198.656 443.733-443.733 443.733-443.733-198.656-443.733-443.733 198.656-443.733 443.733-443.733z M785.067 512l-409.6 273.067v-546.133z',
        ],
        attrs: [
          {
            fill: 'rgb(11, 46, 107)',
          },
          {
            fill: 'rgb(11, 46, 107)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['simulate'],
      },
      attrs: [
        {
          fill: 'rgb(11, 46, 107)',
        },
        {
          fill: 'rgb(11, 46, 107)',
        },
      ],
      properties: {
        order: 4,
        id: 0,
        name: 'simulate',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M0 1024l725.333-512-725.333-512v1024zM853.333 0v1024h170.667v-1024h-170.667z',
        ],
        attrs: [{ fill: 'rgb(0, 81, 196)' }],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['step-forward'],
      },
      attrs: [{ fill: 'rgb(0, 81, 196)' }],
      properties: {
        order: 7,
        id: 0,
        name: 'step-forward',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M464 680c-79.529 0-144 64.471-144 144s64.471 144 144 144v0c79.529 0 144-64.471 144-144s-64.471-144-144-144v0zM464 904c-44.183 0-80-35.817-80-80s35.817-80 80-80v0c44.183 0 80 35.817 80 80s-35.817 80-80 80v0zM1264 680c-0.904-0.020-1.968-0.032-3.036-0.032-79.529 0-144 64.471-144 144s64.471 144 144 144c1.067 0 2.132-0.012 3.194-0.035l-0.158 0.003c78.212-1.701 140.964-65.506 140.964-143.968s-62.752-142.267-140.806-143.965l-0.158-0.003zM1264 904c-0.674 0.020-1.467 0.032-2.263 0.032-44.183 0-80-35.817-80-80s35.817-80 80-80c0.796 0 1.588 0.012 2.378 0.035l-0.116-0.003c43.199 1.261 77.737 36.581 77.737 79.968s-34.539 78.707-77.622 79.965l-0.116 0.003z',
          'M1472 536l-128-32c-36.48-7.68-64-28.8-64-64v-320c0-35.346-28.654-64-64-64v0h-1152c-35.346 0-64 28.654-64 64v0 640c0 35.346 28.654 64 64 64v0h208c0-106.039 85.961-192 192-192s192 85.961 192 192v0h416c0-106.039 85.961-192 192-192s192 85.961 192 192v0h16c35.346 0 64-28.654 64-64v0-160c0-32-26.88-51.84-64-64zM787.84 216c0-17.673 14.327-32 32-32v0h80c17.673 0 32 14.327 32 32v0 80c0 17.673-14.327 32-32 32v0h-80c-17.673 0-32-14.327-32-32v0-80zM568.32 216c0-17.673 14.327-32 32-32v0h79.36c17.673 0 32 14.327 32 32v0 80c0 17.673-14.327 32-32 32v0h-79.36c-17.673 0-32-14.327-32-32v0-80zM348.16 216c0-17.673 14.327-32 32-32v0h80c17.673 0 32 14.327 32 32v0 80c0 17.673-14.327 32-32 32v0h-80c-17.673 0-32-14.327-32-32v0-80zM128 216c0-17.673 14.327-32 32-32v0h80c17.673 0 32 14.327 32 32v0 80c0 17.673-14.327 32-32 32v0h-80c-17.673 0-32-14.327-32-32v0-80zM248.32 680h-96c-1.182 0.204-2.544 0.32-3.932 0.32-13.432 0-24.32-10.888-24.32-24.32s10.888-24.32 24.32-24.32c1.389 0 2.75 0.116 4.075 0.34l-0.143-0.020h96c11.634 1.959 20.388 11.957 20.388 24s-8.753 22.041-20.245 23.98l-0.143 0.020zM152.32 504c-1.182 0.204-2.544 0.32-3.932 0.32-13.432 0-24.32-10.888-24.32-24.32s10.888-24.32 24.32-24.32c1.389 0 2.75 0.116 4.075 0.34l-0.143-0.020h751.36c1.182-0.204 2.544-0.32 3.932-0.32 13.432 0 24.32 10.888 24.32 24.32s-10.888 24.32-24.32 24.32c-1.389 0-2.75-0.116-4.075-0.34l0.143 0.020h-751.36zM912 680h-176c-1.182 0.204-2.544 0.32-3.932 0.32-13.432 0-24.32-10.888-24.32-24.32s10.888-24.32 24.32-24.32c1.389 0 2.75 0.116 4.075 0.34l-0.143-0.020h176c11.634 1.959 20.388 11.957 20.388 24s-8.753 22.041-20.245 23.98l-0.143 0.020zM1152 472c0 17.673-14.327 32-32 32v0h-80c-17.673 0-32-14.327-32-32v0-256c0-17.673 14.327-32 32-32v0h80c17.673 0 32 14.327 32 32v0 256z',
        ],
        attrs: [
          {
            opacity: 0.7,
          },
          {
            opacity: 0.7,
          },
        ],
        width: 1536,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['school-bus-icon'],
      },
      attrs: [
        {
          opacity: 0.7,
        },
        {
          opacity: 0.7,
        },
      ],
      properties: {
        order: 20,
        id: 0,
        name: 'school-bus-icon',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 9,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M906.906 512c0 17.408-1.587 33.792-3.686 50.176l111.053 84.48c9.984 7.68 12.646 21.504 6.298 32.768l-105.267 177.152c-4.571 7.869-12.96 13.075-22.566 13.075-3.433 0-6.711-0.665-9.712-1.874l0.175 0.062-131.072-51.2c-27.341 19.968-56.832 37.376-88.934 50.176l-19.968 135.68c-1.971 12.261-12.475 21.514-25.141 21.514-0.252 0-0.502-0.004-0.752-0.011l0.037 0.001h-210.534c-0.198 0.006-0.431 0.009-0.664 0.009-12.665 0-23.169-9.253-25.121-21.367l-0.019-0.146-19.968-135.68c-33.979-13.79-63.31-30.647-89.944-50.874l0.958 0.698-131.072 51.2c-2.731 1.026-5.887 1.62-9.182 1.62-9.661 0-18.13-5.107-22.854-12.768l-0.066-0.116-105.267-177.152c-2.165-3.655-3.444-8.056-3.444-12.756 0-8.11 3.81-15.331 9.737-19.97l0.056-0.042 111.053-84.48c-2.175-14.931-3.509-32.313-3.685-49.973l-0.002-0.203c0-16.896 1.536-33.792 3.686-50.176l-111.104-84.48c-6.059-4.568-9.936-11.753-9.936-19.842 0-4.781 1.354-9.246 3.699-13.032l-0.061 0.106 105.267-177.152c6.349-11.264 20.019-15.872 32.154-11.264l131.072 51.2c27.341-19.968 56.832-37.376 88.934-50.176l19.968-135.68c1.587-12.288 12.698-21.504 25.805-21.504h210.534c0.117-0.002 0.255-0.003 0.393-0.003 6.374 0 12.215 2.284 16.748 6.078l-0.041-0.033c4.587 3.82 7.756 9.205 8.687 15.325l0.017 0.137 19.968 135.68c32.154 12.8 61.645 29.696 88.986 50.176l131.072-51.2c11.571-4.096 25.805 0 32.102 11.264l105.267 177.152c6.349 11.264 3.686 25.088-6.298 32.768l-111.104 84.48c2.15 16.384 3.738 32.768 3.738 50.176zM510.618 665.6c87.194 0 157.85-68.762 157.85-153.6s-70.656-153.6-157.901-153.6c-87.142 0-157.901 68.762-157.901 153.6s70.707 153.6 157.901 153.6z',
        ],
        attrs: [
          {
            fill: 'rgb(180, 4, 12)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['admin-alert-gear'],
      },
      attrs: [
        {
          fill: 'rgb(180, 4, 12)',
        },
      ],
      properties: {
        order: 2,
        id: 0,
        name: 'admin-alert-gear',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1024 512c0 281.6-230.4 512-512 512s-512-230.4-512-512 230.4-512 512-512 512 230.4 512 512zM384 684.544v68.608h256v-68.608h-80.179v-289.894h-171.213v68.608h83.302v221.286h-87.91zM473.446 319.846c10.752 10.24 23.654 15.411 38.554 15.411 14.387 0 26.982-5.12 37.786-15.411 11.264-10.24 16.947-22.63 16.947-37.018 0-0.078 0.001-0.169 0.001-0.261 0-14.684-6.548-27.838-16.883-36.702l-0.065-0.054c-10.752-10.24-23.398-15.411-37.786-15.411-15.923 0-29.030 4.864-39.322 14.643-9.522 9.082-15.442 21.867-15.442 36.035 0 0.616 0.011 1.229 0.033 1.839l-0.003-0.088c0 14.387 5.376 26.726 16.179 37.018z',
        ],
        attrs: [
          {
            fill: 'rgb(0, 81, 196)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['alert_info_i_round_solid'],
        colorPermutations: {
          1804121811961: [
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(0, 81, 196)',
        },
      ],
      properties: {
        order: 3,
        id: 1,
        name: 'alert_info_i_round_solid',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M910.226 113.778v227.555h-227.557v-227.555h227.557zM568.891 0v455.111h455.109v-455.111h-455.109zM113.778 682.667v227.552h227.555v-227.552h-227.555zM0 1024v-455.111h455.111v455.111h-455.111zM739.555 568.889v170.666h-170.663v113.781h170.663v170.664h113.781v-170.664h170.664v-113.781h-170.664v-170.666h-113.781zM113.778 113.778v227.555h227.555v-227.555h-227.555zM0 455.111v-455.111h455.111v455.111h-455.111z',
        ],
        attrs: [
          {
            fill: 'rgb(11, 46, 107)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['new-collection'],
      },
      attrs: [
        {
          fill: 'rgb(11, 46, 107)',
        },
      ],
      properties: {
        order: 42,
        id: 0,
        name: 'new-collection',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 6,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M682.662 113.778h227.557v227.555h-227.557v-227.555zM568.885 455.111v-455.111h455.108v455.111h-455.108zM113.778 682.664h227.555v227.555h-227.555v-227.555zM0 1024v-455.113h455.111v455.113h-455.111zM341.334 113.778h-227.555v227.555h227.555v-227.555zM0 0v455.111h455.111v-455.111h-455.111zM682.662 682.664h227.557v227.555h-227.557v-227.555zM568.885 1024v-455.113h455.108v455.113h-455.108z',
        ],
        attrs: [
          {
            fill: 'rgb(11, 46, 107)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['use-collection'],
      },
      attrs: [
        {
          fill: 'rgb(11, 46, 107)',
        },
      ],
      properties: {
        order: 9,
        id: 2,
        name: 'use-collection',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 6,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M650.445 20.617h-560.742c-49.562 0-89.702 40.141-89.702 89.702v776.26c0 49.63 40.141 89.771 89.702 89.771h776.329c49.562 0 89.702-40.141 89.702-89.702v-560.879l-305.289-305.152zM238.933 116.19h286.72v244.053c0 23.552-21.299 42.667-47.582 42.667h-191.556c-26.283 0-47.582-19.115-47.582-42.667v-244.053zM860.16 880.777h-764.587v-764.587h69.837v252.655c0 73.182 59.392 132.574 132.506 132.574h177.971c73.182 0 132.574-59.392 132.574-132.574v-252.655h2.799l248.764 248.764v515.823h0.137zM430.080 307.337c26.419 0 47.787-20.070 47.787-44.919v-53.521c0-24.781-21.367-44.851-47.787-44.851s-47.787 20.070-47.787 44.851v53.589c0 24.849 21.367 44.919 47.787 44.919z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['save'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 9,
        id: 2,
        name: 'save',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 6,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M909.331 909.331v-218.131c10.093-19.994 29.702-29.984 58.835-29.984s47.744 9.99 55.834 29.984v218.131c0 30.227-11.558 56.89-34.669 80s-49.773 34.669-80 34.669h-794.664c-30.223 0-56.889-11.558-80-34.669s-34.667-49.773-34.667-80v-794.664c0-30.223 11.555-56.889 34.667-80s49.777-34.667 80-34.667h218.133c21.632 6.549 32.447 24.597 32.447 54.143s-10.815 49.721-32.447 60.524h-218.133v794.664h794.664zM597.333 0h426.667v426.667c-6.714 23.651-25.51 35.476-56.384 35.476-30.88 0-50.304-11.825-58.285-35.476v-232l-559.806 559.81c-33.139 29.338-61.725 31.29-85.759 5.85s-21.343-54.829 8.071-88.166l557.494-557.493h-231.998c-19.158-7.311-28.738-26.591-28.738-57.838s9.58-50.19 28.738-56.829z',
        ],
        attrs: [
          {
            fill: 'rgb(79, 87, 100)',
            opacity: 0.87,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['pop-out'],
      },
      attrs: [
        {
          fill: 'rgb(79, 87, 100)',
          opacity: 0.87,
        },
      ],
      properties: {
        order: 40,
        id: 0,
        name: 'pop-out',
        prevSize: 32,
      },
      setIdx: 1,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M0 278.474v85.477l269.474-269.474v-85.477l-269.474 269.474zM0 525.635v-85.477l269.474-269.474v85.477l-269.474 269.474zM202.267 0h-85.477l-116.79 116.79v85.477l202.267-202.267zM0 601.843v85.477l269.474-269.474v-85.477l-269.474 269.474zM0 849.004v-85.477l269.474-269.474v85.477l-269.474 269.474zM0 925.211v85.477l269.474-269.474v-85.477l-269.474 269.474zM0 1172.372v-85.477l269.474-269.474v85.477l-269.474 269.474zM0 1248.579v6135h269.474v-6404.473l-269.474 269.474zM0 0h40.583l-40.583 40.583v-40.583z',
        ],
        attrs: [
          {
            fill: 'rgb(239, 177, 21)',
          },
        ],
        width: 269,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['warning-banner-pattern'],
      },
      attrs: [
        {
          fill: 'rgb(239, 177, 21)',
        },
      ],
      properties: {
        order: 22,
        id: 0,
        name: 'warning-banner-pattern',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 10,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M538.947 269.474c-148.211 0-269.474 121.263-269.474 269.474 0 107.251 64.135 204.261 162.223 246.838 2.156 12.935 13.474 22.636 26.408 22.636h161.684c12.935 0 24.253-9.701 26.408-22.636 98.088-43.116 161.684-139.587 162.223-246.838 0-148.211-121.263-269.474-269.474-269.474zM431.158 485.053c-29.642 0-53.895-24.253-53.895-53.895s24.253-53.895 53.895-53.895 53.895 24.253 53.895 53.895-24.253 53.895-53.895 53.895zM512 26.947c0-15.091 11.857-26.947 26.947-26.947s26.947 11.857 26.947 26.947v107.789c0 15.091-11.857 26.947-26.947 26.947s-26.947-11.857-26.947-26.947v-107.789zM619.789 862.316c15.091 0 26.947 11.857 26.947 26.947s-11.857 26.947-26.947 26.947h-161.684c-15.091 0-26.947-11.857-26.947-26.947s11.857-26.947 26.947-26.947h161.684zM619.789 970.105c15.091 0 26.947 11.857 26.947 26.947s-11.857 26.947-26.947 26.947h-161.684c-15.091 0-26.947-11.857-26.947-26.947s11.857-26.947 26.947-26.947h161.684zM26.947 565.895c-15.091 0-26.947-11.857-26.947-26.947s11.857-26.947 26.947-26.947h107.789c15.091 0 26.947 11.857 26.947 26.947s-11.857 26.947-26.947 26.947h-107.789zM943.158 565.895c-15.091 0-26.947-11.857-26.947-26.947s11.857-26.947 26.947-26.947h107.789c15.091 0 26.947 11.857 26.947 26.947s-11.857 26.947-26.947 26.947h-107.789zM157.912 196.177c-10.779-10.24-10.779-27.486-0.539-38.265s27.486-10.779 38.265-0.539l76.531 76.531c10.24 10.779 10.24 28.025-0.539 38.265-10.24 10.24-26.947 10.24-37.187 0l-75.992-75.992h-0.539zM805.726 843.992c-10.24-10.779-10.24-28.025 0.539-38.265 10.24-10.24 26.947-10.24 37.187 0l75.992 75.992c10.779 10.779 10.779 27.486 0 38.265s-27.486 10.779-38.265 0l-75.992-75.992h0.539zM881.718 157.912c10.24-10.779 27.486-10.779 38.265-0.539s10.779 27.486 0.539 38.265l-76.531 76.531c-10.779 10.24-28.025 10.24-38.265-0.539-4.744-4.765-7.677-11.337-7.677-18.594s2.933-13.829 7.678-18.595l-0.001 0.001 75.992-75.992v-0.539zM233.903 805.726c10.779-10.24 28.025-10.24 38.265 0.539 10.24 10.24 10.24 26.947 0 37.187l-75.992 75.992c-10.779 10.24-28.025 10.24-38.265-0.539-4.744-4.765-7.677-11.337-7.677-18.594s2.933-13.829 7.678-18.595l-0.001 0.001 75.992-75.992z',
        ],
        attrs: [
          {
            fill: 'rgb(0, 81, 196)',
          },
        ],
        width: 1078,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['notification-bulb'],
      },
      attrs: [
        {
          fill: 'rgb(0, 81, 196)',
        },
      ],
      properties: {
        order: 24,
        id: 1,
        name: 'notification-bulb',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 11,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M853.33 170.653v512h85.334v-597.334h-597.334v85.333h512z',
          'M85.33 341.32h597.334v597.334h-597.334v-597.334zM597.33 426.654h-426.667v426.666h426.667v-426.666z',
          'M725.33 298.654h-512v-85.334h597.334v597.334h-85.334v-512z',
        ],
        attrs: [{}, {}, {}],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['custom-template'],
      },
      attrs: [{}, {}, {}],
      properties: {
        order: 37,
        id: 0,
        name: 'custom-template',
        prevSize: 64,
      },
      setIdx: 0,
      setId: 5,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M26.947 66.317l37.349-39.37 37.107 39.37-37.107 39.128-37.349-39.155zM64.296 175.454l-37.349 39.37 37.349 39.397 37.107-39.37-37.107-39.424zM135.976 179.685l-38.562-37.78 38.616-40.691 35.84 40.691-35.84 37.78zM98.035 289.738l-0.647 0.674 38.616 38.050 37.080-39.343-37.080-39.397-0.054 0.027-38.562 39.343 0.647 0.647zM167.828 214.824l37.349-39.343 37.349 39.316-37.349 39.451-37.349-39.397zM205.177 324.231l-37.349 39.128 37.349 39.37 37.349-39.37-37.349-39.128zM242.526 66.344l-37.349-39.397-37.349 39.37 37.349 39.128 37.349-39.155zM101.403 809.122l-37.107 39.451-37.349-39.397 37.349-39.128 37.107 39.101zM97.388 883.389l38.616 39.37 37.080-39.343-37.080-39.128-38.616 39.101zM243.793 809.122l-37.376 39.451-0.62-0.647-0.62 0.647-37.349-39.37 37.349-39.128 38.616 39.101zM97.388 734.882l38.616 39.37 37.080-38.050-0.62-0.674 0.62-0.647-37.080-38.050-38.616 38.050zM26.947 660.642l37.349 39.128 37.107-39.128-37.107-39.37-37.349 39.37zM101.403 363.358l-37.107 39.37-37.349-39.37 37.349-39.128 37.107 39.128zM64.296 472.495l-37.349 39.37 37.349 39.37 37.107-39.343-37.107-39.397zM97.523 437.464l-0.135-0.108 38.616-38.858 37.080 39.101-37.080 39.397-38.616-39.397 0.135-0.108zM136.003 547.032l-38.616 39.128 0.135 0.135-0.135 0.135 38.616 39.101 37.080-39.101-37.080-39.397zM167.963 512l-0.135-0.135 37.349-39.101 37.349 39.101-37.349 39.37-37.349-39.101 0.135-0.135zM205.177 621.002l-37.349 39.37 0.135 0.135-0.135 0.135 37.349 39.128 37.349-39.128-0.135-0.135 0.135-0.135-37.349-39.343zM26.947 957.709l37.349 39.343 37.107-39.37-37.107-39.128-37.349 39.155zM242.526 957.709l-37.349 39.343-37.349-39.37 37.349-39.128 37.349 39.155z',
        ],
        attrs: [
          {
            fill: 'rgb(180, 4, 12)',
          },
        ],
        width: 269,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['zone-alert-pattern'],
        colorPermutations: {
          18041212482482491255255255150106247177151: [
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(180, 4, 12)',
        },
      ],
      properties: {
        order: 31,
        id: 1,
        name: 'zone-alert-pattern',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 12,
      iconIdx: 0,
    },
    {
      icon: {
        paths: ['M0 0h269.474v1024h-269.474z'],
        attrs: [
          {
            fill: 'rgb(50, 106, 247)',
          },
        ],
        width: 269,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['info-banner-pattern'],
        colorPermutations: {
          18041212482482491255255255150106247177151: [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(50, 106, 247)',
        },
      ],
      properties: {
        order: 32,
        id: 2,
        name: 'info-banner-pattern',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 12,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1121.28 843.093l-447.716-782.791c-20.874-36.068-59.275-59.945-103.253-59.945s-82.379 23.877-102.948 59.374l-0.305 0.571-449.422 782.791c-10.168 17.305-16.174 38.116-16.174 60.33 0 65.694 52.525 119.12 117.87 120.574l0.135 0.002h898.844c65.972-0.831 119.132-54.505 119.132-120.595 0-22.206-6.002-43.011-16.471-60.88l0.308 0.569zM625.778 824.889h-113.778v-113.778h113.778v113.778zM625.778 540.444c0 31.419-25.47 56.889-56.889 56.889s-56.889-25.47-56.889-56.889v0-113.778c0-31.419 25.47-56.889 56.889-56.889s56.889 25.47 56.889 56.889v0 113.778z',
          'M625.778 711.111h-113.778v113.778h113.778v-113.778zM625.778 540.444v-113.778c0-31.419-25.47-56.889-56.889-56.889s-56.889 25.47-56.889 56.889v0 113.778c0 31.419 25.47 56.889 56.889 56.889s56.889-25.47 56.889-56.889v0z',
        ],
        attrs: [
          {
            fill: 'rgb(239, 177, 21)',
          },
          {
            fill: 'rgb(7, 7, 15)',
          },
        ],
        width: 1138,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['warning_banner_black_exclaim'],
        colorPermutations: {
          23917721177151: [
            {
              f: 1,
            },
            {
              f: 0,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(239, 177, 21)',
        },
        {
          fill: 'rgb(7, 7, 15)',
        },
      ],
      properties: {
        order: 37,
        id: 0,
        name: 'warning_banner_black_exclaim',
        prevSize: 32,
        code: 59648,
        codes: [59648, 59649],
      },
      setIdx: 0,
      setId: 13,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z',
          'M453.925 601.819h91.355v-18.286c0-11.264 1.682-20.992 5.12-29.257 4.255-9.362 10.352-17.216 17.88-23.389l0.113-0.090c8.485-7.607 20.334-15.726 35.474-24.503 24.357-14.263 42.789-30.72 55.15-49.298 12.434-18.871 18.651-41.253 18.651-67.218v-0.731c0-26.185-6.875-49.298-20.699-69.266-14.347-20.473-33.708-36.522-56.335-46.543l-0.863-0.341c-24.357-11.264-53.029-16.896-85.87-16.896-35.109 0-65.17 6.071-89.966 18.286-24.649 12.142-43.593 29.184-56.905 50.981-13.166 21.65-20.041 46.446-20.699 74.533v0.731l93.111-0.439 0.731-0.293c0.366-12.394 3.878-23.895 9.761-33.826l-0.179 0.326c5.658-9.506 13.599-17.119 23.089-22.226l0.316-0.156c9.546-4.991 20.85-7.919 32.838-7.919 0.592 0 1.183 0.007 1.772 0.021l-0.087-0.002c13.166 0 24.576 2.487 34.45 7.534 18.468 8.758 31.024 27.225 31.086 48.632l0 0.008v0.731c0.010 0.44 0.015 0.959 0.015 1.48 0 9.642-1.914 18.838-5.382 27.227l0.173-0.474c-4.313 9.197-10.371 16.917-17.806 23.023l-0.114 0.091c-8.265 7.314-19.895 15.506-34.816 24.43-15.653 9.216-28.379 19.090-38.254 29.696-9.238 9.966-16.273 22.111-20.246 35.569l-0.161 0.636c-2.613 10.076-4.114 21.644-4.114 33.562 0 4.821 0.245 9.584 0.725 14.278l-0.049-0.59 0.731 19.968zM503.223 768c19.31 0 34.45-5.12 45.495-15.506 11.264-10.386 16.896-24.357 16.896-42.057 0-18.139-5.632-32.329-16.896-42.423-10.971-10.313-26.185-15.506-45.495-15.506s-34.597 5.12-45.861 15.506c-11.264 10.094-16.896 24.283-16.896 42.423 0 17.701 5.632 31.744 16.823 42.057 11.337 10.313 26.624 15.506 45.934 15.506z',
          'M512 950.857v0c-242.374 0-438.857-196.483-438.857-438.857s196.483-438.857 438.857-438.857v0c242.374 0 438.857 196.483 438.857 438.857s-196.483 438.857-438.857 438.857zM512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512v0c-282.77 0-512 229.23-512 512s229.23 512 512 512v0z',
        ],
        attrs: [
          { fill: 'rgb(255, 255, 255)' },
          { fill: 'rgb(11, 46, 107)' },
          { fill: 'rgb(140, 150, 162)' },
        ],
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['question_mark_tooltip'],
        colorPermutations: {
          '1146107114015016212552552551': [{ f: 2 }, { f: 0 }, { f: 1 }],
        },
      },
      attrs: [
        { fill: 'rgb(255, 255, 255)' },
        { fill: 'rgb(11, 46, 107)' },
        { fill: 'rgb(140, 150, 162)' },
      ],
      properties: {
        order: 2,
        id: 0,
        name: 'question_mark_tooltip',
        prevSize: 32,
        code: 59648,
        codes: [59648, 59649, 59650],
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M9.01511 0.0666572C7.25504 -0.160874 5.46922 0.197708 3.93279 1.08698C3.10866 1.56398 2.38085 2.17945 1.77789 2.90075V1.76614C1.77789 1.27522 1.37992 0.877247 0.888997 0.877247C0.398078 0.877247 0.000108644 1.27522 0.000108644 1.76614V5.32834C0.000108644 5.81926 0.398078 6.21723 0.888997 6.21723H1.31665C1.3277 6.21744 1.33874 6.21744 1.34977 6.21723H4.44455C4.93547 6.21723 5.33344 5.81926 5.33344 5.32834C5.33344 4.83742 4.93547 4.43946 4.44455 4.43946H2.83482C3.35689 3.70305 4.03354 3.08275 4.82334 2.62562C6.02188 1.93191 7.41466 1.65233 8.78719 1.82976C10.1597 2.0072 11.4362 2.63185 12.42 3.60785C13.4037 4.58388 14.0401 5.85713 14.2308 7.23158C14.2982 7.71784 14.7471 8.05736 15.2333 7.98991C15.7196 7.92246 16.0591 7.47358 15.9917 6.98732C15.7476 5.22741 14.9326 3.59647 13.6721 2.34582C12.4115 1.09515 10.7752 0.294187 9.01511 0.0666572Z',
          'M1.76946 8.76842C1.70201 8.28216 1.25313 7.94264 0.766867 8.01009C0.280604 8.07754 -0.0589118 8.52642 0.00853875 9.01268C0.252658 10.7726 1.06759 12.4035 2.32815 13.6542C3.58874 14.9049 5.22504 15.7058 6.98511 15.9333C8.74518 16.1609 10.531 15.8023 12.0674 14.913C12.8916 14.436 13.6194 13.8205 14.2223 13.0992V14.2339C14.2223 14.7248 14.6203 15.1228 15.1112 15.1228C15.6021 15.1228 16.0001 14.7248 16.0001 14.2339V10.6717C16.0001 10.1807 15.6021 9.78277 15.1112 9.78277H14.6836C14.6725 9.78256 14.6615 9.78256 14.6505 9.78277H11.5557C11.0647 9.78277 10.6668 10.1807 10.6668 10.6717C10.6668 11.1626 11.0647 11.5605 11.5557 11.5605H13.1654C12.6433 12.297 11.9667 12.9172 11.1769 13.3744C9.97833 14.0681 8.58555 14.3477 7.21303 14.1702C5.84049 13.9928 4.56399 13.3681 3.58026 12.3921C2.5965 11.4161 1.96011 10.1429 1.76946 8.76842Z',
        ],
        attrs: [{}, {}],
        width: 16,
        height: 16,
        grid: 0,
        tags: ['update'],
      },
      attrs: [{}, {}],
      properties: {
        order: 200,
        id: 100,
        name: 'update',
        prevSize: 32,
        code: 59818,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 100,
    },
  ],
  height: 1024,
  metadata: {
    name: 'icomoon',
  },
  preferences: {
    showGlyphs: true,
    showCodes: true,
    showQuickUse: true,
    showQuickUse2: true,
    showSVGs: true,
    fontPref: {
      prefix: 'icon-',
      metadata: {
        fontFamily: 'icomoon',
        majorVersion: 1,
        minorVersion: 0,
      },
      metrics: {
        emSize: 1024,
        baseline: 6.25,
        whitespace: 50,
      },
      embed: false,
      autoHost: true,
    },
    imagePref: {
      prefix: 'icon-',
      png: false,
      useClassSelector: true,
      color: 460565,
      bgColor: 16777215,
      name: 'icomoon',
      classSelector: '.icon',
      height: 24,
      columns: 16,
      margin: 16,
    },
    historySize: 50,
    quickUsageToken: {
      Icons: 'NTU0OGFhMmZmNTc2ZDFkNTgyMTEzZDJhM2I0MzRlMGMjMSMxNTcxNDMzNDY2IyMj',
    },
    gridSize: 16,
    showLiga: true,
    showGrid: false,
  },
}
export default iconMoon.icons.reduce(
  (acc, curr) => ({
    ...acc,
    [curr.properties.name]: curr,
  }),
  {}
)
